
import { Name } from 'constants/fieldname';
import { Field } from 'helpers/FormImports';
//import { ClientDataColumn, CommonDataColumn } from 'models/BaseModel';

enum ActiveStatus {
    ACTIVE = 2,
    DELETE = 3,
    COMMON = 8,
    
    NEW = 9,
    EMPTY = 99,

    YES = 49,
    NO = 50
  }

  
enum SortBy {
    ASC = 1,
    DESC = 0,
  }

enum Oriantation {
    PORTRAIT = 10,
    LANDSCAPE = 11
  }

enum DataView {
    LIST = 10,
    GROUP = 11,
    SUMMARY = 12
  }

enum Align {
    LEFT = 1,
    RIGHT = 2,
    CENTER = 3,
  }

enum ExamMap {
  FINALRX = 1,
  FINALRX2 = 2,
  MEDICATION = 3,
  CLTRAIL = 4,
  CLTRAIL2 = 5,
  CLFINAL = 6,

  FIELD_AHC = 7,
  FIELD_DOB = 8,
  FIELD_PHONE = 9,
  FIELD_ADDRESS = 10,
  FIELD_CLIENT_ID = 11,
  FIELD_DISPENSER = 12,
}

enum ColumnType {
  TEXT = 31,
  AMOUNT = 32,
  NUMBER = 33,
  DATE = 34,
  TIME = 35,
}

enum ColumnSummary {
  SUM = 10,
  COUNT = 11,
  AVERAGE = 12,
  MAXIMUM = 13,
  MINIMUM = 14
}

enum ChartType {
  NONE = 4,
  BAR = 10,
  LINE = 11,
  PIE = 12,
  DOUGHNUT = 13,
}

enum ClientNameFormat {
  ADDRESS_PHONE = 10,
  AGE_ADDRESS = 11,
  AGE = 12,
  AGE_GENDER = 13,
}

enum ModeofPay {
  CASH = 51,
  MISC= 52,
  CARD = 53,
  DEBITCARD = 54,
  CREDITCARD = 55,
  MOBILE = 56,
  ONLINE = 57,
  CHEQUE = 58,
  EFT = 59,
  WIRE = 60,
  GIFTCARD = 61,
  ETRANSFER = 62,
  INSURANCE = 63,
  AADL = 64,
  AMEX = 65,
  RAMP = 66,
  DIRECTDEPOSIT = 67,
  MO = 68,
  CONTACTLESS = 69,
  INSTORECREDIT = 70,
  OTHER = 71,
  MASTERCARD = 72,
  VISA = 73,
  WRITEOFF = 74,
  INSCHEQUE = 75,
  AHC = 76,
}

enum CreditOptions {
  STOCKOUT = 21,
  WALLET = 22,
  DELIVERY = 23,
}

enum Session {
  TODAY = 10,
  YESTERDAY = 11,
  TOMORROW = 12,
  THIS_WEEK = 13,
  LAST_WEEK = 14,
  NEXT_WEEK = 15,
  THIS_MONTH = 16,
  LAST_MONTH = 17,
  NEXT_MONTH = 18,
  THIS_QUARTER = 19,
  LAST_QUARTER = 20,
  NEXT_QUARTER = 21,
  THIS_YEAR = 22,
  LAST_YEAR = 23,
  NEXT_YEAR = 24,
  LAST_2_YEAR = 25,
  LAST_3_YEAR = 26,
  LAST_4_YEAR = 27,
  LAST_5_YEAR = 28,
  CUSTOM = 99,
}

const GroupModoOfPay = {
  TERMINAL: [ModeofPay.CARD,ModeofPay.DEBITCARD,ModeofPay.CREDITCARD,ModeofPay.AMEX,ModeofPay.MASTERCARD,ModeofPay.VISA],
  GOVTINSURANCE: [ModeofPay.AADL,ModeofPay.AHC,ModeofPay.INSURANCE,ModeofPay.INSCHEQUE,ModeofPay.DIRECTDEPOSIT,ModeofPay.ETRANSFER],
  CASH: [ModeofPay.CASH],
  OTHERS: [ModeofPay.CHEQUE, ModeofPay.MISC]
}

enum MessageSegment {
  WELCOME = 10,
  PICKUP	= 11,
  APPOINTMENT	= 12
}

enum CommonOptions {
    NOTHING = -1,
    SELECT = 0,
    ALL = 1,
    NA = 2,
    GENERAL = 3,
    NONE = 4,
    UNAVAILABLE = 5,
    TOP = 6,
    BLANK = 7,
  } 

enum BillingStatus
{
  TOSUBMIT = 80,
  SUBMITTED = 81,
  INPROCESS = 82,
  PAID = 83,
  REFUSED = 84,
  WRITEOFF = 85,
  HOLD = 86,
  RESUBMIT = 87,
}

enum Privilege
{
  ALL = 10, //show in role
  VIEW = 11, //show in role
  OPEN = 12, //show in role
  CREATE = 13, //show in role
  UPDATE = 14, //show in role
  DELETE = 15, //show in role
  PRINT = 16, //show in role
  CALL = 17,
  EMAIL = 18,
  FAX = 19,
  EXPORT = 20, //show in role
  APPROVE = 21,
  HISTORY = 22,  //show in role
  ADVANCE = 23,
  ADMIN = 24,  //show in role
  ALLLOC = 25  //show in role
}

enum FormSize {
    XXSMALL = 5, //540px
    XSMALL = 6, //600px
    SMALL = 7, //700px
    MEDIUM = 8, //800px
    LARGE = 9, //900px
    XLARGE = 10, //1000px
    XXLARGE = 11, //1100px
    XXXLARGE = 12, //1200px
    HUGE = 13, //1300px
    MAX = 14, //1400px
  }

enum MessageType {
    INFO = 1,
    CONFIRMTION = 2,
    EMPTY_FIELDS = 3,
    ERROR = 4,
    WARNING = 5,
  }
  
  enum PriorityType {
    VERY_HIGH = 30,
    HIGH = 31,
    NORMAL = 32,
    LOW = 33,
    VERY_LOW = 34,
  }
  

export const MessageNone = {
    messages: [],
    type: 0,
  }

enum PopupClose {
    ALWAYS = 1,
    ONCREATE = 2,
    NONE = 3,
    REMAINOPEN = 4,
    REDIRECT = 5,
  }

// enum HtmlDataFormat {
//     EXAM = 10,
//     FRAME = 11,
//     PRESCRIPTION = 12,
//     LENS = 13,
//   }
  
const HtmlTag = {
    break: '<br/>',
}

const OptionTitle = {
    NA: 'N/A',
}

const ImageName = {
    profile: 'profile',
    thumb: 'thumb',
    signature: 'signature',
    logo: 'logo',
    map: 'map',
    banner: 'banner',
    document1: 'document1',
    document2: 'document2',
    document3: 'document3',
    document4: 'document4',
    document5: 'document5',
    photo1: 'photo1',
    photo2: 'photo2',
    photo3: 'photo3',
    thumb1: 'thumb1',
    thumb2: 'thumb2',
    thumb3: 'thumb3',
  }

  const ChartColor = {
    color1: 'rgba(48, 161, 237, 1)', // Blue Sky
    color2: 'rgba(255, 94, 128, 1)', // Bright Pink
    color3: 'rgba(75, 192, 192, 1)', // Teal
    color4: 'rgba(255, 148, 43, 1)', // Orange
    color5: 'rgba(0, 191, 111, 1)', // Green
    color6: 'rgba(249, 190, 0, 1)', // Mustard Yellow
    color7: 'rgb(170, 41, 250)', // Purple
    color8: 'rgba(255, 87, 34, 1)', // Deep Orange
    color9: 'rgba(0, 188, 212, 1)', // Cyan
    color10: 'rgba(255, 64, 129, 1)', // Neon Pink
    color11: 'rgba(124, 77, 255, 1)', // Violet
    color12: 'rgba(0, 230, 118, 1)', // Lime Green
    color13: 'rgba(255, 214, 0, 1)', // Yellow
    color14: 'rgba(41, 121, 255, 1)', // Bright Blue
    color15: 'rgb(248, 63, 100)', // Bold Red-Pink
    color16: 'rgba(0, 229, 255, 1)', // Light Aqua
    color17: 'rgba(255, 138, 101, 1)', // Coral
    color18: 'rgba(186, 104, 200, 1)', // Light Purple
    color19: 'rgba(100, 255, 218, 1)', // Minty Cyan
    color20: 'rgba(255, 171, 145, 1)', // Peach
  }

const DateTimeFormat = {
  Date: 'yyyy-MM-dd',
  Full: 'yyyy-MM-dd HH:mm tt',
  Time: 'HH:mm',
  TimeTT: 'hh:mm tt',
  TimeSS: 'HH:mm:ss',
}

const SnoFormat = {
  Common7: '0000000{X}(10:C;11:P;12:N;)',
  Common6: '000000{X}(10:C;11:P;12:N;)',
}

const CalendarView = {
  DayGrid: 'timeGridDay',
  DayList: 'listDay',
  WeekGrid: 'timeGridWeek',
  WeekList: 'listWeek',
  MonthGrid: 'dayGridMonth',
  MonthList: 'listMonth',
}

const urlParameter = {
  CalendarView: 'view',
  Date: 'date',
  StartDate: 'sdate',
  EndDate: 'edate',
  Form: 'fmid',
  Common: 'cmid',
  Doctor: 'drid',
  Branch: 'brid',
  Client: 'clid',
  Exam: 'exid',
  Family: 'fmid',
  Invoice: 'inid',
  Segment: 'sgid',
  Insurer: 'isid',
  Amount: 'amt',
  Sequence: 'sqid',
  Product: 'prid',
  Sale: 'slid',
  SaleOrder: 'soid',
}

const ActionAHS = {
  Add: 'A',
  Change: 'C',
  Delete: 'D',
  Reassess: 'R',
}

const FileName = {
    ACTIVE: "active",
    RELATION: "relation",
    AUTH_METHOD: "authmethod",
    CITY: "city",
    DOCTOR: "doctor",
    RECDOCTOR: "recdoctor",
    PRODUCT: "product",
    EXAM: "exam",
    DEPARTMENT: "meddept",
    EMPLOYEE: "employee",
    TITLE: "title",
    GENDER: "gender",
    SUBMITTER: "submitter",
    SPECIALIZATION: "specialization",
    MARITAL: "marital",
    SALEITEMTYPE: "saleitemtype",
    OCCUPATION: "occupation",
    SERVER: "server",
    DATABASE: "database",
    LOCATION: "location",
    ROLE: "role",
    PROVINCE: "province",
    ACCOUNT: "account",
    ROW: "row",
    PRIORITY: "priority",
    USER: "user",
    FORM: "form",
    TERM: "term",
    COLUMN: "column",
    SPECIAL: "special",
    UNIT: "unit",
    YESNO: "yesno",
    CONSENT: "consent",
    SESSION: "session",
    FORMAT: "format",
    DIRECTION: "direction",
    GRIDLINE: "gridline",
    BASE: "base",
    CHART: "chart",
    ORIENTATION: "orientation",
    TAX: "tax",
    OFFER: "offer",
    SEGMENT: "segment",
    CATEGORY: "category",
    CREDIT: "credit",
    SUPPLIER: "supplier",
    FEATURE: "feature",
    INSURER: "insurer",
    INSURANCE: "insurance",
    CONTROL: "control",
    TEMPLATE: "template",
    BANK: "bank",
    SEQUENCE: "sequence",
    CHECK: "check",
    STATUS: "status",
    MODE: "mode",
    MOP: "modepay",
    Payee: "payee",
    HSC: "hsc",
    DIAG: "diag",
    CLAIM: "claim",
    REMITTANCE: "remit",
    GROUP: "group",
    OPTION: "option",
    EXAMTYPE: "examtype",
    SPECIFICATION: "specification",
    STOCK: "stock",
    REPORT: "report",
    LIST: "list",
    ORDER: "order",
    WIDTH: "width",
    ALIGN: "align",
    SUMMARY: "summary",
    DATA: "data",
    BY: "by",
    ACTION: "action",
    DEFAULT: "default",
    TYPE: "type",
    VIEW: "view",
    ALL: "all",
};

const DropFieldsMapping = {
  role: {
    value: 'role_id',
    label: 'role_name'
  },
  product: {
    value: 'product_id',
    label: ['product_number','product_name']
  },
  client: {
    value: 'client_id',
    label: ['client_number','client_first_name','client_middle_name','client_last_name','client_address','client_phone']
  },
  payee: {
    value: 'payee_id',
    label: 'payee_name'
  },
  user: {
    value: 'user_id',
    label: ['user_first_name','user_middle_name','user_last_name']
  },
  doctor: {
    value: 'doctor_id',
    label: ['doctor_first_name','doctor_middle_name','doctor_last_name']
  }
}

const ItemNoneCalculateFields = [
  Name.Item.SKU,
  Name.Product.Name, 
  Name.Item.Comment, 
  Name.Common.Selected
];

// const Token = {
//     ACCESS: "accessToken",
//     REFRESH: "refreshToken",
// };

const TermCommon = {
  INVOICE: `
    <p><strong>Thank you for visiting us!</strong></p>
    <p>I acknowledge that I have received the listed products/services in good condition and as described on this invoice.</p>
    <p>I consent to the secure electronic use and storage of my information in accordance with applicable privacy laws, and to related communications using my contact details. I will notify the store of any changes in my family group.</p>
    <p>I agree to all the terms and conditions mentioned above.</p>
  `,
  PROFORMA: `
    <p><strong>Thank you for visiting us!</strong></p>
    <p>This is a proforma invoice for quotation purposes only and not a final tax invoice.</p>
    <p>Prices, availability, and specifications are subject to change without notice. Applicable taxes and charges may apply.</p>
    <p>I consent to the secure electronic use and storage of my information in accordance with applicable privacy laws, and to related communications using my contact details.</p>
    <p>I agree to all the terms and conditions mentioned above.</p>
  `,
};

const Tab = {
  Tab1: "tab1",
  Tab2: "tab2",
  Tab3: "tab3",
  Tab4: "tab4",
  Tab5: "tab5",
  Tab6: "tab6",
  Tab7: "tab7",
  Tab8: "tab8",
  Tab9: "tab9",
  Tab10: "tab10",
  Tab11: "tab11",
  Tab12: "tab12",
  Tab13: "tab13",
  Tab14: "tab14",
  Tab15: "tab15",
  Tab16: "tab16",
  Tab17: "tab17",
  Tab18: "tab18",
  Tab19: "tab19",
  Tab20: "tab20",
};

const FormName = {
  EDIT: 'editform',
  COMPANY: "company",
  LOCATION: "location",
  SETTINGS: "settings",
  REPORT: "report",
  REPORTS: "reports",
  CALENDAR: "calendar",
  USER: "user",
  ROLE: "role",
  COUNTRY: "country",
  PROVINCE: "province",
  CITY: "city",
  GROUP: "group",
  UNIT: "unit",
  PRODUCT: "product",
  HISTORY: "history",
  BANK: "bank",
  CLIENT: "client",
  SUPPLIER: "supplier",
  PAYEE: "payee",
  INVOICE: "invoice",
  PURCHASE: "purchase",
  SALERETURN: "salereturn",
  PURCHASERETURN: "purchasereturn",
  PURCHASECREDIT: "purchasecredit",
  ESTIMATE: "estimate",
  PURCHASEORDER: "purchaseorder",
  PROFORMA: "proforma",
  PAYMENT: "payment",
  STAGE: "stage",
  CONSENT: "consent",
  PAYOUT: "payout",
  CHALLAN: "challan",
  VOUCHER: "voucher",
  CREDITNOTE: "creditnote",
  DEBITNOTE: "debitnote",
  TAX: "tax",
  TERM: "term",
  CURRENCY: "currency",
  PREMIUM: "premium",
  OFFER: "offer",
  COUPON: "coupon",
  BRAND: "brand",
  ADDRESS: "address",
  SEGMENT: "segment",
  CATEGORY: "category",
  SUBCATEGORY: "subcategory",
  CHECK: "check",
  STOCK: "stock",
  REQUISITION: "requisition",
  ISSUE: "issue",
  EMPLOYEE: "employee",
  INQUIRY: "inquiry",
  APPOINTMENT: "appointment",
  PROJECT: "project",
  TASKS: "tasks",
  SCHEDULE: "schedule",
  INBOX: "inbox",
  DOCUMENT: "document",
  BILLING: "billing",
  BOOKING: "booking",
  WAREHOUSE: "warehouse",
  ACTIVITY: "activity",
  TRANSFER: "transfer",
  DELIVERY: "delivery",
  EQUIPMENT: "equipment",
  ITEM: "item",
  DESIGNATION: "designation",
  ATTENDANCE: "attendance",
  LEAVE: "leave",
  DEPARTMENT: "department",
  EARNING: "earning",
  DEDUCTION: "deduction",
  QUALIFICATION: "qualification",
  HOLIDAY: "holiday",
  LOAN: "loan",
  LOANINSTALMENT: "loaninstalment",
  EXPERIENCE: "experience",
  SHIFT: "shift",
  SHELF: "shelf",
  RACK: "rack",
  SALARYHEAD: "salaryhead",
  RECRUITMENT: "recruitment",
  TIME: "time",
  DOCTOR: "doctor",
  NOTE: "note",
  EXAM: "exam",
  INSURER: "insurer",
  INSURANCE: "insurance",
  PRESCRIPTION: "prescription",
  RECALL: "recall",
  EXAMTYPE: "examtype",
  TOORDER: "to order",
  ONORDER: "on order",
  CREDITPENDING: "creditpending",
  CREDITCANCEL: "creditcancel",
  LOST: "lost",
  TRASNFERIN: "trasnferin",
  TRANSFEROUT: "transferout",
  CREDITRECEIVED: "creditreceived",
  DAMAGED: "damaged",
  FORMS: "forms",
  CONTROLS: "controls",
  DATABASE: "database",
  SERVER: "server",
  ACCOUNTHEAD: "accounthead",
  ORDERS: "orders",
  COLUMN: "column",
  ACTION: "action",
  TEMPLATE: "template",
  DAYBOOK: "daybook",
  CREDIT: "credit",
  CARD: "card",
  COMMUNICATION: "communication",
  CLAIM: "claim",
  REMITTANCE: "remittance",
  INVENTORY: "inventory",
  MANAGER: "manager",
  REFERRAL: "referral",
  RECDOCTOR: "recdoctor",
  WORKHOUR: "workhour",
  BREAK: "break",
  CHAT: "chat",
  DISPATCH: "dispatch",
  EXAMRATE: "examrate",
  FEATURE: "feature",
  FORM: "form",
  LANGUAGE: "language",
  LOGS: "logs",
  MEDICATION: "medication",
  MERGE: "merge",
  OPTION: "option",
  PRIVILEGE: "privilege",
  SESSION: "session",
  OFFICEHOUR: "office hour",
  SUBMITTER: "submitter",
  TIMEZONE: "timezone",
  DISPENSE: "dispense",
  RELEASE: "release",
  MARKING: "marking",
  MISSING: "missing",
  PRINT: "print",
  SALE: "sale",
  SALEORDER: "saleorder",
  SALEITEM: "saleitem",
  EXAMTEMPLATE: "examtemplate",
  INTAKE: "intake",
};

enum ProductCategory {
    MEDICINE = 10,
    EQUIPMENT =	11,
    CONTACTLENS =12,
    FRAME =	13,
    SUNGLASSES =	14,
    LENS =	15,
    COATING =	16,
    EXAM =	17,
    HYGIENIC =	18,
    HEARING_AID =	20,
    BATH_SAFETY =	21,
    CHAIRS =	22,
    HRA =	23,
    INCONTINENCE =	24,
    KNEEBRACE =	25,
    MATTRESS =	26,
    MEDICAL_SUPPORT =	27,
    ORTHOTICS =	28,
    DISPENSING =	29,
    STOCKING =	30,
    SUPPLEMENT =	31,
    WALKINGAIDS =	34,
    ORDER =	35,
    CLFITTINGS =	36,
    LENSADDONS =	37,
    MEDICAL =	39,
    CLSOLUTION =	40,
    SAVARIA =	41,
    ADDON =	43,
    SAFETYPARTS =	44,
    REPAIRS =	45,
    OPAQUE =	46,
    UNITRON =	50,
    HEARING_AID_BATTERIES =	51,
    PHARMACY =	52,
    JOBST =	54,
    SIGVARIS =	55,
    BAUERFEIND =	56,
    SIGNIA =	59,
    OTICON =	62,
    RENTAL =	63,
    BEDS_ACCESSORIES = 64,
    LIFT =	65,
    MOBILITY =	66,
    RAMPS =	67,
    DIAPER =	68,
    DROPS =	69,
    MISC =	70,
    SERVICE =	71,
    CATHETER =	73,
    DEAL =	74,
}

enum ProductId {
  FRAME = 2825,
  LENS = 2653,
  PRESCRIPTION = 2713,
  CL = 2858,
}

enum FormId {
  COMPANY = 100,
  LOCATION = 101,
  SETTINGS = 102,
  REPORTS = 103, // execute reports
  CALENDAR = 104,
  USER = 105,
  ROLE = 106,
  COUNTRY = 107,
  PROVINCE = 108,
  CITY = 109,
  GROUP = 110,
  UNIT = 111,
  PRODUCT = 112,
  HISTORY = 113,
  TERM = 114,
  BANK = 115,
  CLIENT = 116,
  SUPPLIER = 117,
  INVOICE = 118,
  PURCHASE = 119,
  SALERETURN = 120,
  PURCHASERETURN = 121,
  ESTIMATE = 122,
  PURCHASEORDER = 123,
  PROFORMA = 124,
  PAYMENT = 125,
  PAYOUT = 126,
  CHALLAN = 127,
  VOUCHER = 128,
  CREDITNOTE = 130,
  DEBITNOTE = 131,
  TAX = 132,
  CURRENCY = 133,
  PREMIUM = 134,
  DISCOUNT = 135,
  COUPON = 136,
  PROMOTION = 137,
  PROGRAM = 138,
  REWARDS = 139,
  BRAND = 140,
  ADDRESS = 141,
  SEGMENT = 142,
  CATEGORY = 143,
  SUBCATEGORY = 144,
  CHECK = 145,
  STOCK = 146,
  CONTROLS = 147,
  REQUISITION = 149,
  ISSUE = 150,
  EMPLOYEE = 151,
  INQUIRY = 152,
  APPOINTMENT = 153,
  PROJECT = 154,
  TASKS = 155,
  SCHEDULE = 156,
  INBOX = 157,
  DOCUMENT = 158,
  BILLING = 159,
  BOOKING = 161,
  WAREHOUSE = 162,
  ACTIVITY = 164,
  TRANSFER = 165,
  DELIVERY = 167,
  DATABASE = 168,
  SERVER = 169,
  EQUIPMENT = 170,
  ITEM = 171,
  DESIGNATION = 172,
  ATTENDANCE = 173,
  LEAVE = 174,
  DEPARTMENT = 175,
  EARNING = 177,
  DEDUCTION = 178,
  QUALIFICATION = 179,
  HOLIDAY = 180,
  LOAN = 181,
  LOANINSTALMENT = 182,
  EXPERIENCE = 183,
  SHIFT = 184,
  SHELF = 185,
  RACK = 186,
  SALARYHEAD = 189,
  ACCOUNTHEAD = 190,
  RECRUITMENT = 191,
  TIME = 192,
  DOCTOR = 193,
  NOTE = 194,
  EXAM = 195,
  INSURER = 196,
  INSURANCE = 197,
  PRESCRIPTION = 198,
  RECALL = 199,
  EXAMTYPE = 200,
  TOORDER = 201,
  ONORDER = 202,
  CREDITPENDING = 203,
  CREDITCANCEL = 204,
  LOST = 205,
  TRANSFERIN = 206,
  TRANSFEROUT = 207,
  CREDITRECEIVED = 208,
  DAMAGED = 209,
  OFFER = 210,
  CHAT = 215,
  DISPATCH = 216,
  EXAMRATE = 217,
  FEATURE = 218,
  FORM = 219,
  LANGUAGE = 220,
  LOGS = 221,
  MEDICATION = 222,
  MERGE = 223,
  MODE = 224,
  OPTION = 225,
  PRIVILEGE = 226,
  REPORT = 227,  // edit reports
  SESSION = 228,
  OFFICEHOUR = 229,
  SUBMITTER = 230,
  TIMEZONE = 231,
  MARKING = 233,
  MISSING = 234,
  CAMPAIGN = 235,
  MESSENGER = 236,
  EXAMTEMPLATE = 244,
  RELEASE = 250,
  DISPENSE = 255,
  ORDERS = 261,
  COLUMN = 262,
  ACTION = 263,
  TEMPLATE = 264,
  DAYBOOK = 265,
  CREDIT = 266,
  CARD = 267,
  COMMUNICATION = 268,
  CLAIM = 269,
  REMITTANCE = 270,
  INVENTORY = 271,
  MANAGER = 272,
  REFERRAL = 273,
  RECDOCTOR = 274,
  WORKHOUR = 275,
  BREAK = 276,
  SALE = 277,
  SALEORDER = 278,
  SALEITEM = 279,
  PAYEE = 280,
  STAGE = 281,
  INTAKE = 282,
  PURCHASECREDIT = 283,

  STOCKIN = 147,
  STOCKOUT = 148,
};

enum DocumentType {
  PROFILE = 100,
  SALE = 101,
  INVOICE = 102,
  PROFORMA = 103,
  ORDER = 104,
  DISPENSE = 105,
  ESTIMATE = 106,
  DELIVERY = 107,
  PRESCRIPTION = 108,
  REFERRALIN = 109,
  REFERRALOUT = 110,
  SALERETURN = 111,
  PURCHASEORDER = 112,
  PURCHASE = 113,
  PURCHASERETURN = 114,
  MISSING = 115,
  CLAIM = 116,
  REMITTANCE = 117,
  LABORDER = 118,
  SALEFORM = 119,
  RELEASE = 120,
  EXAM = 121,
  TELUS = 1161,
  SUNLIFE = 1162,
}

const CommandName = {
    ON_POPUP_FORM_CLOSE: "REFRESH_AFTER_CLOSE_POPUP"
};

const CommandKey = {
    NEW: 'new',
    NEWID: 'newid'
};

const controlName = {
  CHECKBOX: 'input[type="checkbox"].select:checked',
};

const paths = { 
    SERVER: 'https://api.nextvizon.com/api/v1/',
    //LOCAL: 'https://app.nextvizon.com/',
    LOCAL: 'https://app2.nextvizon.com/',
    //SERVER: 'http://localhost:5000/api/v1/',
    //LOCAL: 'http://localhost:3000/',
    //SERVER: 'http://35.183.47.188:5000/api/v1/',
    //LOCAL: 'http://app2.nextvizon.com.s3-website.ca-central-1.amazonaws.com/',
    //LOCAL: 'http://app.nextvizon.com.s3-website.ca-central-1.amazonaws.com/',
    LOGIN: 'auth/login',
    NO_PRIVILEGE: '/no-privilege',
    //NO_PRIVILEGE: '/pages/no-privilege.html',
};

const localStorageKey = {
  RefreshToken: 'gjRtQwZl2T3kMf',
  AccessToken: 'TrAt2kJy5NxPq4',
  CompanyKey: 'LmCkyPzJ38vXqK',
  LocationKey: 'b4LkZQ92tMwKY7',
  UserKey: 'QwUiTmP9zKxL38',
  DoctorKey: 'p9DkXlJY4VtQmK',
  DoctorList: 'geDlbNwM4zYt5Qm',
  EmployeeKey: 'M2EkwZK7NqP3Vt',
  CompanyName: 'JXCnT5QmP4zYL8',
  LocationName: 'KXLnV9NwM2T3pZ',
  LocationColor: 'jkLcj9pwg4k3lc',
  UserName: 'T5UnJXqPY79KZ4',
  PrivilegeList: 'X7PlQmK9wPZJY5',
  SpecialList: 'b4SlT5XJmPZK79',
  ReportList: 'xPRlJY4VtQwKLM',
  DocumentList: 'yRDlJr6htWxQpN',
  FileList: 'T3FlkXlJpPzJ3v',
  OptionValues:'xPovxL38kXlJmP',
  examValues:'djEv5P3K694gtQ',
};

const FormOption = {
  control: (base: any) => ({
    ...base,
    textAlign: "left",
    color: "#000",
    borderRadius: 4,
    borderColor: "#dedede",
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 9l6 6 6-6' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`, 
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    backgroundSize: "16px",
    paddingRight: 10,
    height: "34px",  // Set height to 36px
    minHeight: "34px", // Set min-height to 36px
    fontSize: "15px",
  }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    textAlign: "left",
    color: isSelected ? "#0073aa" : "#000",
    backgroundColor: isSelected ? "#eee" : isFocused ? "#f3f4f6" : "transparent", 
    fontSize: "15px",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#000", 
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "#000"
  }),
  indicatorsContainer: () => ({
    display: "none", 
  }),
  dropdownIndicator: () => ({
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    maxHeight: "300px", 
  }),
 menuList: (base: any) => ({
    ...base,
    maxHeight: "300px",
    overflowY: "auto",
  }),
};

const SearchOption = {
  control: (base: any) => ({
    ...base,
    textAlign: "left",
    color: "#000",
    borderRadius: 4,
    borderColor: "#dedede",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0'/%3E%3C/svg%3E")`, 
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    backgroundSize: "16px",
    paddingRight: 10,
    height: "34px",  // Set height to 36px
    minHeight: "34px", // Set min-height to 36px
    fontSize: "15px",
  }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    textAlign: "left",
    color: isSelected ? "#0073aa" : "#000",
    backgroundColor: isSelected ? "#eee" : isFocused ? "#f3f4f6" : "transparent", 
    fontSize: "15px",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#000", 
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "#000"
  }),
  indicatorsContainer: () => ({
    display: "none", 
  }),
  dropdownIndicator: () => ({
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    maxHeight: "300px", 
  }),
 menuList: (base: any) => ({
    ...base,
    maxHeight: "300px",
    overflowY: "auto",
  }),
};

const ListOption = {
  control: (base: any) => ({
    ...base,
    textAlign: "left",
    color: "#000",
    borderRadius: 4,
    borderColor: "#dedede",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0'/%3E%3C/svg%3E")`, 
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    backgroundSize: "16px",
    paddingRight: 10,
    height: "28px",  // Set height to 36px
    minHeight: "28px", // Set min-height to 36px
    fontSize: "13px",
  }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    textAlign: "left",
    color: isSelected ? "#fff" : isFocused ? "#fff" : "#000",
    backgroundColor: isSelected ? "#1967d2" : isFocused ? "#1967d2" : "transparent", 
    fontSize: "13px",
    lineHeight: "16px",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#000", 
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "#000",
    height: "28px",
  }),
  input: (provided: any) => ({
    ...provided,
    margin: "0px", // Remove unnecessary margins
    padding: "0px", // Remove padding
    height: "16px",
  }),
  indicatorsContainer: () => ({
    display: "none", 
  }),
  dropdownIndicator: () => ({
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    maxHeight: "150px", 
  }),
 menuList: (base: any) => ({
    ...base,
    maxHeight: "150px",
    overflowY: "auto",
  }),
};

export enum Group {
  SEGMENT = 9,
  PAYOUT = 10,
  PRODUCT = 11,
  PRODUCT_TYPE = 12,
  COLLECTION_MODE = 13,
  CHECK_STATUS = 14,
  INVOICE_TYPE = 15,
  DELIVERY_TYPE = 16,
  DELIVERY_STATUS = 17,
  USER_TYPE = 18,
  USER_STATUS = 19,
  PURCHASE_TYPE = 20,
  STOCK_TYPE = 21,
  PROFORMA_STATUS = 22,
  SALERETURN_TYPE = 23,
  CHALLAN_TYPE = 24,
  ESTIMATE_TYPE = 25,
  PURCHASEORDER_TYPE = 26,
  PURCHASERETURN_TYPE = 27,
  REQUISITION_TYPE = 28,
  ISSUE_TYPE = 29,
  EMPLOYEE_TYPE = 30,
  EMPLOYEE_STATUS = 31,
  CITIZENSHIP = 32,
  INQUIRY_TYPE = 33,
  INQUIRY_STATUS = 34,
  INQUIRY_RESPONSE = 35,
  INQUIRY_DURATION = 36,
  INQUIRY_INTERESTED = 37,
  INQUIRY_CONTACT = 38,
  PROJECT_TYPE = 39,
  PROJECT_STATUS = 40,
  DOCUMENT_TYPE = 41,
  DOCUMENT_STATUS = 42,
  DOCUMENT_ISSUE = 43,
  INVOICE_TERMS = 44,
  ESTIMATE_TERMS = 45,
  PROFORMA_TERMS = 46,
  PURCHASE_TERMS = 47,
  DELIVERY_TERMS = 48,
  REQUISITION_TERMS = 49,
  ISSUE_TERMS = 50,
  SALERETURN_TERMS = 51,
  PURCHASEORDER_TERMS = 52,
  PURCHASERETURN_TERMS = 53,
  RECRUITMENT_STATUS = 55,
  LEAVE_TYPE = 56,
  NOTE_TYPE = 57,
  NOTE_STATUS = 58,
  EXAM_TYPE = 59,
  EXAM_STATUS = 60,
  DOCUMENT_FOLDER = 61,
  DOCUMENT_FORMAT = 62,
  DOCUMENT_AVAILABILITY = 63,
  SCHEDULE_TYPE = 64,
  SCHEDULE_STATUS = 65,
  DOCTOR_TYPE = 66,
  DOCTOR_STATUS = 67,
  APPOINTMENT_TYPE = 68,
  APPOINTMENT_STATUS = 69,
  MEDICAL_HISTORY = 70,
  INSURANCE_TYPE = 71,
  PRESCRIPTION_TYPE = 72,
  PRESCRIPTION_STATUS = 73,
  MEDICATION_FREQUENCY = 74,
  RECALL_TYPE = 75,
  RECALL_STATUS = 76,
  BANK_TYPE = 77,
  COLLECTION_TYPE = 78,
  ANTERIOR_LIDS = 80,
  ANTERIOR_CONJUNCTIVA = 81,
  ANTERIOR_CORNEA = 82,
  ANTERIOR_ANGLES = 83,
  ANTERIOR_CHAMBER = 84,
  ANTERIOR_IRIS = 85,
  ANTERIOR_LENS = 86,
  ANTERIOR_VITREOUS = 87,
  POSTERIOR_CD_RATIO = 88,
  POSTERIOR_OPTIC_NERVE_HEAD = 89,
  POSTERIOR_MACULA = 90,
  POSTERIOR_VASCULATURE = 91,
  POSTERIOR_POLE = 92,
  POSTERIOR_PERIPHERY = 93,
  POSTERIOR_METHOD = 94,
  POSTERIOR_OCT = 95,
  EXAM_UNAIDEDMETHOD = 96,
  EXAM_AIDEDMETHOD = 97,
  EXAM_RXWORN = 98,
  EXAM_CYCLOPLEGIC_METHOD = 99,
  EXAM_SUBJECTIVE_METHOD = 100,
  EXAM_KERATOMETRY_METHOD = 101,
  EXAM_KERATOMETRY_MIRE_QUALITY = 102,
  MEDICAL_DEPARTMENT = 103,
  PRODUCT_COLOR = 104,
  PRODUCT_STYLE = 105,
  PRODUCT_SHAPE = 106,
  PRODUCT_MATERIAL = 107,
  PRODUCT_FEATURE = 108,
  PRESCRIPTION_TERMS = 109,
  EXAM_TERMS = 110,
  ORDER_TYPE = 111,
  ORDER_TERMS = 112,
  ORDER_STATUS = 113,
  INVOICE_STATUS = 114,
  ESTIMATE_STATUS = 115,
  ORDER_FRAME_STATUS = 116,
  TASKS_TYPE = 117,
  TASKS_STATUS = 118,
  THIRD_PARTY = 119,
  APPOINTMENT_INFO = 120,
  COMMNUCATION_TYPE = 121,
  COMMNUCATION_STATUS = 122,
  DIAGNOSIS_HEALTH = 123,
  DIAGNOSIS_HEALTH_DESC = 124,
  DIAGNOSIS_REFRACTION = 125,
  DIAGNOSIS_REFRACTION_DESC = 126,
  DIAGNOSIS_BINOCULAR_VISION = 127,
  DIAGNOSIS_BINOCULAR_VISION_DESC = 128,
  DIAGNOSIS_RECALLS = 129,
  DIAGNOSIS_RECALLS_DESC = 130,
  COLOR_VISION_TEST = 131,
  COLOR_VISION_EYE = 132,
  COLOR_VISION_DIAG = 133,
  ANTERIOR_ADNEXA = 134,
  COVER_TEST_BOX1 = 135,
  COVER_TEST_BOX5 = 136,
  FIELDS_TEST = 137,
  FIELDS_RESULT = 138,
  FIELDS_RELIABILITY = 139,
  EOM_STEREOPSIS = 140,
  EOM_STEREOPSIS_DESC = 141,
  PUPILS = 142,
  ANTERIOR_PUNCTA = 143,
  GONIOSCOPY_ANGLES = 144,
  GONIOSCOPY_ANGLES2 = 145,
  GONIOSCOPY_PIGMENT = 146,
  GONIOSCOPY_ANGLES_RECESSION = 147,
  GONIOSCOPY_NEOVASCULARZATION = 148,
  GONIOSCOPY_APPROACH = 149,
  ANTSEGCL_CENTRATION = 150,
  ANTSEGCL_MOVEMENT = 151,
  ANTSEGCL_ROTATION = 152,
  ANTSEGCL_CONDITION = 153,
  ANTSEGCL_VISUAL_ACUITY = 154,
  ANTSEGCL_PUNCTA = 155,
  CONTACT_LENS_FITTING_STATUS = 156,
  CONTACT_LENS_SUPPLIER = 157,
  CONTACT_LENS_TYPE = 158,
  CONTACT_LENS_NAME = 159,
  CONTACT_LENS_COLOUR = 160,
  CONTACT_LENS_SOLUTION = 161,
  DROPS = 162,
  RETINOSCOPY_METHOD = 163,
  MANAGER_TYPE = 164,
  MANAGER_STATUS = 165,
  MANAGER_MODE = 166,
  REFERRAL_STATUS = 167,
  RECDOCTOR_TYPE = 168,
  COVER_TEST_BOX2 = 167,
  COVER_TEST_BOX3 = 168,
  COVER_TEST_BOX4 = 169,
  ANTERIOR_PALPEBRAL = 170,
  COLOR_VISION_DIAGNOSIS = 171,
  ADDITIONAL_HIRSCHBERG = 172,
  ADDITIONAL_BRUCKNER = 173,
  FAMILY_OCULAR = 174,
  PATIENT_OCULAR = 175,
  PATIENT_MEDICAL = 176,
  WORKHOUR_TYPE = 177,
  WORKHOUR_STATUS = 178,
  BREAK_TYPE = 179,
  BREAK_STATUS = 180,
  PAID_UNPAID = 181,
  LEAVE_STATUS = 182,
  SHIFT_TYPE = 183,
  SHIFT_STATUS = 184,
  TIME_TYPE = 185,
  TIME_STATUS = 186,
  TONOMETRY_METHOD = 187,
  DISPENSE_TYPE = 188,
  DISPENSE_STATUS = 189,
  DISPENSE_TERMS = 190,
  MISSING_TYPE = 191,
  MISSING_STATUS = 192,
  CAMPAIGN_TYPE = 193,
  CAMPAIGN_STATUS = 194,
  MESSENGER_TYPE = 195,
  MESSENGER_STATUS = 196,
  CATEGORY_TYPE = 197,
  CATGEORY_STATUS = 198,
  INSURANCE_STATUS = 199,
  INSURANCE_RELATION = 200,
  PAYOUT_TYPE = 201,
  PAYOUT_STATUS = 202,
  PROFORMA_TYPE = 203,
  RELEASE_TYPE = 204,
  RELEASE_TERMS = 205,
  RELEASE_STATUS = 206,
  SALERETURN_STATUS = 207,
  PURCHASERETURN_STATUS = 208,
  SALE_STATUS = 209,
  PURCHASECREDIT_TYPE = 210,
  PURCHASECREDIT_STATUS = 211
}

export enum InventoryColumn {
  BRAND = 10,
  MODEL = 11,
  COLOR = 12,
  SIZE = 13
}

export enum ControlType {
  EXAM = 100,
  LENS = 106,
  FRAME = 107,
  CONTACTLENS = 108,
  COATING = 110,
  STOCKING = 112,
  MEDICAL = 113,
  HEARING = 114,
}

export enum ActionType {
  SETTLE	= 10,
  HOLD	= 11,
  CANCELLED	= 12,
  PAID	= 13,
  PARTIALPAID	= 14,
  UNPAID	= 15,
  ORDERED	= 16, 
  SOLD	= 17,
  RETURNED	= 18,
  REFUNDED	= 19,
  PICKUP	= 20,
  DELIVERED	= 21,
  ORDERPLACED	= 22,
  RECEIVED	= 23,
  WARRANTY	= 24,
  NOTPICKED	= 25,
  DUE	= 26,
  PENDING	= 27,
  COMPLETED	= 28,
  FINAL	= 29,
  SENTTOLAB	= 30,
  ARRIVEDVERIFIED	= 31,
  ARRIVED	= 32,
  VERIFIED	= 33,
  PXNOTIFIED	= 34,
  PXLEFTMESSAGE	= 35,
  PXCALLED	= 36,
  DAMAGED	= 37,
  LOST	= 38,
  ONAPPROVAL	= 39,
  POF	= 40,
  SCRATCHED	= 41,
  TRANSFERRED	= 42,
  ENOTIFIED	= 43,
  MISSING	= 44,
  TOORDER	= 45
}

export enum SegmentType {
  HEARINGAID	= 31,
  MEDICAL	= 32,
  OPTICAL	= 33,
  RENTAL	= 34,
  STAIRLIFT	= 35,
  WASHROOM	= 36
}

export const ControlTitleMap: Record<string, string> = {
    [ControlType.FRAME]: "Frame",
    [ControlType.EXAM]: "Exam",
    [ControlType.CONTACTLENS]: "Contact Lens",
    [ControlType.LENS]: "Lens",
    [ControlType.STOCKING]: "Stocking",
    [ControlType.HEARING]: "Hearing Aid",
    [ControlType.MEDICAL]: "Medical",
    [ControlType.COATING]: "Coating",
  };

export enum ExamType {
  FINALRX = 10,
  FINALRX2 = 11,
  CLTRIAL1 = 12,
  CLTRIAL2 = 13,
  CLFINAL = 14,
}

export enum StockId
{
  UNKNOWN =  9,
  INSTOCK =  10,
  SOLD =  11,
  ORDERED = 12,
  LOST = 13,
  DAMAGED = 14,
  CANCELLED = 15,
  CREDITRECEIVED = 16,
  CREDITPENDING = 17,
  CREDITCANCELLED = 18,
  ASSIGNED = 19,
}

export enum Control_Old {
  LENS = 10,
  FRAME = 11,
  CL = 12,
  SUNGLASSES = 13,
  Coating = 14,
  STOCKING = 15,
  MEDICAL = 16,
  HEARINGAID = 17,
}

export enum ExamOption {
  SPHERE = 10,
  ADD = 11,
  PRISM = 12,
  ORIENT = 13,
  ACUITY = 14,
  CYLINDER = 15,
  AXIS = 16,
  BCURVE = 17,
  LENSTYPE = 18,
  TINTED = 19,
  EYE = 20,
  FREQUENCY = 21,
  PIN = 22,
}

export const Title = {
  Empty: '',
  Date: 'Date',
  Time: 'Time',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  Start: 'Start',
  End: 'End',
  SNo: 'SNo.',
  Doctor: 'Doctor',
  DoctorName: 'Doctor Name',
  RecDoctor: 'Rec. Doctor',
  Issue: 'Issue Date',
  Expiry: 'Expiry Date',
  Team: 'Team',
  BillNo: 'Bill Number',
  BillDate: 'Bill Date',
  DOB: 'DOB',
  Age: 'Age',
  DateOfBirth: 'Date of Birth',
  Product: 'Product Name',
  Barcode: 'Barcode',
  Model: 'Model',
  Desc: 'Description',
  Item: 'Item',
  User: 'User',
  Payee: 'Payee',
  UserName: 'User Name',
  Bank: 'Bank',
  Title: 'Title',
  Client: 'Patient',
  ClientName: 'Patient Name',
  ClientDOB: 'Patient DOB',
  PaidTo: 'Paid to',
  PolicyNumber: 'Policy Number',
  MemberNumber: 'Member Id',
  GroupNumber: 'Group Number',
  ProjectName: 'Project Name',
  PrimaryHolder: 'Primary Holder',
  SecondaryHolder: 'Secondary Holder',
  ClientId: 'Patient Id',
  Segment: 'Segment',
  Color: 'Colour',
  Paid: 'Paid',
  HSC: 'HSC',
  Diagnosis: 'Diagnosis#',
  Diag: 'Diag',
  Diag1: 'Diag 1',
  Diag2: 'Diag 2',
  Diag3: 'Diag 3',
  Category: 'Category',
  Template: 'Template',
  Utncode: 'UTN Code',
  Skucode: 'SKU Code',
  SkuUtn: 'SKU/UTN Code',
  Serial: 'Serial No',
  Price: 'Price',
  Cost: 'Cost',
  Role: 'Role',
  Source: 'Source',
  Status: 'Status',
  State: 'State',
  Submitby: 'Submitted by',
  PostCheck: 'Post Check',
  Type: 'Type',
  Specification: 'Specification',
  Exam: 'Exam',
  Priority: 'Priority',
  Rows: 'Rows',
  Offer: 'Offer',
  Location: 'Location',
  Brand: 'Brand Name',
  Mode: 'Mode',
  Group: 'Group',
  Action: 'Action',
  Payment: 'Payment',
  Payout: 'Payout',
  Receipt: 'Receipt No',
  Qty: 'Qty.',
  Quantity: 'Quantity',
  Unit: 'Unit',
  Gross: 'Gross',
  Deposit: 'Deposit',
  Tax: 'Tax',
  Percentage: 'Percentage (%)',
  GSTP: 'GST(%)',
  GST: 'GST',
  Amount: 'Amount',
  Rate: 'Rate',
  Credit: 'Cash Back',
  Billed: 'Billed',
  Claimed: 'Claimed',
  Remittance: 'Remittance',
  Received: 'Received',
  Unpaid: 'Unpaid',
  Balance: 'Balance',
  GiftCard: 'Gift Card',
  Case: 'Case',
  Terminal: 'Terminal',
  Cash: 'Cash',
  Check: 'Check',
  Cheque: 'Cheque',
  Other: 'Other',
  Insurance: 'Insurance',
  Total: 'Total',
  Count: 'Count',
  CashInHand: 'Cash-in-hand',
  MRN: 'MRN',
  ExamSNo: 'Exam SNo',
  ExamDate: 'Exam Date',
  Invoice: 'Invoice',
  InvoiceNo: 'Invoice No',
  InvoiceDate: 'Invoice Date',
  OrdersNo: 'Order No',
  OrdersDate: 'Order Date',
  Proforma: 'Proforma',
  ProformaNo: 'Proforma No',
  ProformaDate: 'Proforma Date',
  Estimate: 'Estimate',
  EstimateNo: 'Estimate No',
  EstimateDate: 'Estimate Date',
  Delivery: 'Delivery',
  DeliveryNo: 'Delivery No',
  DeliveryDate: 'Delivery Date',
  Dispense: 'Dispense',
  DispenseNo: 'Dispense No',
  DispenseDate: 'Dispense Date',
  Release: 'Release',
  ReleaseNo: 'Release No',
  ReleaseDate: 'Release Date',
  SubTotal: 'Sub Total',
  Subject: 'Subject',
  Insurer: 'Insurer',
  Insurer1: 'Insurer 1',
  Insurer2: 'Insurer 2',
  MOP: 'Mode of pay',
  Dispenser: 'Dispenser',
  ReceivedFrom: 'Received from',
  ReceivedBy: 'Received by',
  CreatedBy: 'Created by',
  ModifiedBy: 'Modifed by',
  NetAmount: 'Net Amount',
  Roundoff: 'Round Off',
  Payable: 'Payable',
  Receivable: 'Receivable',
  Code: 'Code',
  Refno: 'Ref. No.',
  RefSno: 'Ref. SNo.',
  GovKey: 'GovKey',
  FileNo: 'File No.',
  Registration: 'Registration No.',
  Server: 'Server',
  Database: 'Database',
  Particular: 'Particular',
  Name: 'Name',
  Comment: 'Comments',
  Internal: 'Internal Comments',
  Content: 'Contents',
  History: 'History',
  Remarks: 'Remarks',
  Stock: 'Stock',
  Terms: 'Terms',
  Company: 'Company',
  DiscountP: 'Discount(%)',
  Discount: 'Discount',
  Disc: 'Disc.',
  Taxable: 'Taxable',
  Phone: 'Phone',
  Cell: 'Cell',
  Mobile: 'Mobile',
  Home: 'Home',
  Email: 'Email',
  Fax: 'Fax',
  Website: 'Website',
  Address: 'Address',
  AssignedBy: 'Assigned by',
  AssignedTo: 'Assigned to',
  Postal: 'Postal',
  City: 'City',
  Supplier: 'Supplier',
  Province: 'Province',
  Country: 'Country',
  Gender: 'Gender',
  Marital: 'Marital Status',
  Occupation: 'Occupation',
  refer: 'Referred by',
  Login: 'Login',
  Password: 'Password',
  AssoEmail: 'Associated Email',
  Profile: 'Profile Image',
  Photo: 'Image',
  Logo: 'Logo',
  Signature: 'Signature',
  HealthCard: 'Health Card',
  FirstName: 'First Name',
  MiddleName: 'Middle Name',
  LastName: 'Last Name',
  RoleName: 'Role Name',
}

export const Info = {
  SoftwareName: 'Next Vizon',
  SoftwareVersion: '2.0',
  DisableAddProduct: 'Please click [SAVE] to enable adding product.',
  AddProduct: 'Add product to the list',
  ProfileSize: '* Suggested size for the profile photo: Width 400px, Height 400px',
  SignSize: '* Suggested size for the signature: Width 300px, Height 100px.',
  LogoSize: '* Suggested size for the signature: Width 300px, Height 200px.',
  ProductSize: '* Suggested size for the Product Image: Width 400px, Height 400px',
}

export const Class = {
  ptop1: 'pt1',
  ptop2: 'pt2',
  ptop3: 'pt3',
  ptop4: 'pt4',
}

export const ClientMultiField = {
  Family:{
    FatherHistory: 'D16',
    MotherHistory: 'D17',
    BrotherHistory: 'D18',
    SisterHistory: 'D19',
  },
  HearingAid: {
    MakeModel: 'D26',
    LeftSNo: 'D27',
    RightSNo: 'D28',
    Remote: 'D29',
    Charger: 'D30',
    Battery: 'D31',
    Receiver: 'D32',
    Domes: 'D33',
    Waxguards: 'D39',
    FitDate: 'D34',
    Warranty: 'D35',
    LossDamage: 'D36',
    Info: 'D38',
  },
  Physician:{
    Name:'D23',
    Phone:'D24',
    Fax:'D37',
    ClinicName:'D25',
  },
  Emergency:{
    ContactName: 'D20',
    Relation: 'D21',
    Phone: 'D22',
  }
}

export const Denomination = {
  dollar100: 'dollar100',
  dollar50: 'dollar50',
  dollar20: 'dollar20',
  dollar10: 'dollar10',
  dollar5: 'dollar5',
  dollar2: 'dollar2',
  dollar1: 'dollar1',
  cent50: 'cent50',
  cent25: 'cent25',
  cent10: 'cent10',
  cent5: 'cent5'
}

export const ReportColumn = {
  row: 'row',
  id: 'id',
  title: 'title',
  align: 'align',
  prefix: 'prefix',
  postfix: 'postfix',
  summary: 'summary',
} 

export const ReportChart = {
  show: 'show',
  type: 'type',
  format: 'format',
  axis: 'axis',
  base: 'base',
  grid: 'grid',
  stack: 'stack',
  title: 'title',
  bar1: 'bar1',
  bar2: 'bar2',
  bar3: 'bar3',
  bar4: 'bar4',
  bar5: 'bar5',
  bar6: 'bar6',
  bar7: 'bar7',
  bar8: 'bar8',
}

export enum ExamFieldGroup {
    Complaint = 100,
    Ocular = 101,
    Medical = 102,
    Unaided = 103,
    Aided = 104,
    Pupils = 105,
    Fields = 106,
    CoverTest = 107,
    ColorVision = 108,
    ColorVision2 = 109,
    Stereopsis = 110,
    Additional = 111,
    Binocular = 112,
    Retino = 113,
    Amplitude = 114,
    Drops = 115,
    Anterior = 116,
    Puncta = 117,
    Posterior = 118,
    Gonioscopy = 119,
    Fields2 = 120,
    Prescription = 121,
    Medications = 122,
    MedicationFull = 123,
    Diagnosis = 124,
    Habitual = 125,
    Habitual2 = 126,
    Tonometry = 127,
    Tonometry2 = 128,
    Over = 129,
    Keratom = 130,
    Pachymetry = 131,
    Subjective = 132,
    Autorefraction = 133,
    FinalAdd = 134,
    Balance = 135,
    FinalRx = 136,
    FinalRx2 = 137,
    Cycloplegic = 138,
    Pd = 139,
    Other = 140,
    CLTrial = 141,
    CLTrial2 = 142,
    CLFinal = 143,
    AnteriorCL = 144,
    ContactLens = 145,
    PosteriorPhoto = 146,
    Eom = 147,
    Prelims = 148,
    Npc = 149,
    Bcc = 150,
}

export const ExamField = {
  NA: 'NA',
  Complaint:{
    Date: 'T52',
    Primary: 'D28',
    Secondary: 'D29',
    Notes: 'T10',
  },
  Ocular:{
    Date: 'T53',
    Family: 'D22',
    Client: 'D23',
    EyeSurgery: 'D24',
    EyeInjury: 'D36',
    Notes: 'D21',
  },
  Medical: {
    Date: 'T54',
    ClientHistory: 'D25',
    FamilyHistory: 'D26',
    FamilyDoctor: 'D27',
    Medications: 'D30',
    Allergies: 'D31',
    EmergencyContact: 'D32',
    Smoker: 'D33',
    Pregnant: 'D62',
    Diabetic: 'D63',
    WhenDiagnosed: 'D34',
    CurrentBloodSugar: 'D35',
    FamilyHistoryOfDiabetes: 'C93',
    EmergencyContactName: 'D16',
    EmergencyContactRelation: 'D17',
    EmergencyContactPhone: 'D18',
    EmergencyAltPhone: 'D19',
  },
  CoverTest: {
    Date: 'T59',
    DxStrab: 'R102',
    DxSide: 'R103',
    DxRate: 'R104',
    DxDeviation: 'R105',
    DxDirection: 'R106',
    NxStrab: 'L102',
    NxSide: 'L103',
    NxRate: 'L104',
    NxDeviation: 'L105',
    NxDirection: 'L106',
    Notes: 'T22',
  },
  Fields: {
    Date: 'T58',
    Test: 'C42',
    ODResult: 'R119',
    OSResult: 'L119',
    ODReliability: 'R120',
    OSReliability: 'L120',
    Notes: 'T27',
  },
  Fields2: {
    Date: 'T69',
    Test: 'T33',
    ODResult: 'R231',
    OSResult: 'L231',
    ODReliability: 'R232',
    OSReliability: 'L232',
    Notes: 'T34',
  },
  Keratom: {
    Date: 'T47',
    ODHoriz: 'R91',
    ODAxis: 'R92',
    ODVert: 'R93',
    OSHoriz: 'L91',
    OSAxis: 'L92',
    OSVert: 'L93',
    ODHoriz2: 'R94',
    ODAxis2: 'R95',
    ODVert2: 'R96',
    OSHoriz2: 'L94',
    OSAxis2: 'L95',
    OSVert2: 'L96',
    Method: 'C22',
  },
  Autorefraction: {
    Date: 'T86',
    ODSphere: 'R85',
    OSSphere: 'L85',
    ODCylinder: 'R86',
    OSCylinder: 'L86',
    ODAxis: 'R89',
    OSAxis: 'L89',
    ODAcuity: 'R90',
    OSAcuity: 'L90',
    Method: 'C36',
    Notes: 'T16',
  },
  Subjective: {
    Date: 'T48',
    ODSphere: 'R29',
    OSSphere: 'L29',
    ODCylinder: 'R30',
    OSCylinder: 'L30',
    ODAxis: 'R31',
    OSAxis: 'L31',
    ODAcuity: 'R32',
    OSAcuity: 'L32',
    OUAcuity: 'C23',
    Method: 'C24',
    Notes: 'T14',
    ODPrism: 'R168',
    OSPrism: 'L168',
    ODOrient: 'R170',
    OSOrient: 'L170',
    ODPrism2: 'R169',
    OSPrism2: 'L169',
    ODOrient2: 'R171',
    OSOrient2: 'L171',
  },
  Balance: {
    Date: 'T82',
    ODSphere: 'R125',
    OSSphere: 'L125',
    ODCylinder: 'R126',
    OSCylinder: 'L126',
    ODAxis: 'R127',
    OSAxis: 'L127',
    ODAcuity: 'R128',
    OSAcuity: 'L128',
    OUAcuity: 'B128',
    Method: 'T84',
    Notes: 'T83',
    ODPrism: 'R129',
    OSPrism: 'L129',
    ODOrient: 'R130',
    OSOrient: 'L130',
    ODPrism2: 'R131',
    OSPrism2: 'L131',
    ODOrient2: 'R132',
    OSOrient2: 'L132',
  },
  FinalAdd: {
    Date: 'T81',
    WorkingDistance: 'C55',
    ODFinalAdd: 'R175',
    OSFinalAdd: 'L175',
    ODAcuity: 'R176',
    OSAcuity: 'L176',
    OUAcuity: 'B43',
    Notes: 'T41',
  },
  FinalRx: {
    Date: 'T49',
    Lens: 'C74',
    MatteTinted: 'C32',
    ODSphere: 'R67',
    OSSphere: 'L67',
    ODCylinder: 'R68',
    OSCylinder: 'L68',
    ODAxis: 'R69',
    OSAxis: 'L69',
    ODAdd: 'R75',
    OSAdd: 'L75',
    ODPd: 'R135',
    OSPd: 'L135',
    ODAcuity: 'R70',
    OSAcuity: 'L70',
    OUAcuity: 'C33',
    ODPrism: 'R71',
    OSPrism: 'L71',
    ODOrient: 'R72',
    OSOrient: 'L72',
    ODPrism2: 'R79',
    OSPrism2: 'L79',
    ODOrient2: 'R80',
    OSOrient2: 'L80',
    Method: 'C34',
    Notes: 'T13',
    RxDate: 'D67',
    RxExpiry: 'D68',
  },
  FinalRx2: {
    Date: 'T50',
    Lens: 'C75',
    MatteTinted: 'C68',
    ODSphere: 'R206',
    OSSphere: 'L206',
    ODCylinder: 'R207',
    OSCylinder: 'L207',
    ODAxis: 'R208',
    OSAxis: 'L208',
    ODAdd: 'R210',
    OSAdd: 'L210',
    ODPd: 'R136',
    OSPd: 'L136',
    ODAcuity: 'R209',
    OSAcuity: 'L209',
    OUAcuity: 'C69',
    ODPrism: 'R211',
    OSPrism: 'L211',
    ODOrient: 'R212',
    OSOrient: 'L212',
    ODPrism2: 'R213',
    OSPrism2: 'L213',
    ODOrient2: 'R214',
    OSOrient2: 'L214',
    Method: 'C70',
    Notes: 'T31',
    RxDate: 'D69',
    RxExpiry: 'D70',
  },
  Pd: {
    Date: 'T79',
    DxOD: 'R16',
    DxOS: 'L16',
    DxOU: 'B16',
    NxOD: 'R17',
    NxOS: 'L17',
    NxOU: 'B17',
    Notes: 'T80',
  },
  Other: {
    Date: 'D59',
    DxOD: 'R59',
    DxOS: 'L59',
    DxOU: 'B59',
    NxOD: 'R60',
    NxOS: 'L60',
    NxOU: 'B60',
    Notes: 'D60',
  },
  Anterior: {
    Date: 'T65',
    ODAdnexa: 'R101',
    OSAdnexa: 'L101',
    ODLidsLashes: 'R44',
    OSLidsLashes: 'L44',
    ODPalpebral: 'R43',
    OSPalpebral: 'L43',
    ODConjunctiva: 'R45',
    OSConjunctiva: 'L45',
    ODCornea: 'R46',
    OSCornea: 'L46',
    ODAngles: 'R47',
    OSAngles: 'L47',
    ODChamber: 'R48',
    OSChamber: 'L48',
    ODIris: 'R49',
    OSIris: 'L49',
    ODLens: 'R50',
    OSLens: 'L50',
    ODVitreous: 'R51',
    OSVitreous: 'L51',
    ODPuncta: 'R143',
    OSPuncta: 'L143',
    Notes: 'T20',
  },
  Tonometry: {
    Date: 'T46',
    ODIOP: 'R99',
    OSIOP: 'L99',
    ODIOP2: 'R100',
    OSIOP2: 'L100',
    ODIOP3: 'R137',
    OSIOP3: 'L137',
    Time: 'D20',
    Method: 'C21',
    Notes: 'T17',
  },
  Tonometry2: {
    Date: 'T234',
    ODIOP: 'R234',
    OSIOP: 'L234',
    ODIOP2: 'R235',
    OSIOP2: 'L235',
    ODIOP3: 'R236',
    OSIOP3: 'L236',
    Time: 'D234',
    Method: 'D235',
    Notes: 'D236',
  },
  Posterior: {
    Date: 'T67',
    ODCDRatio: 'R52',
    OSCDRatio: 'L52',
    ODOpticNerveHead: 'R53',
    OSOpticNerveHead: 'L53',
    ODMacula: 'R54',
    OSMacula: 'L54',
    ODVasculature: 'R55',
    OSVasculature: 'L55',
    ODPole: 'R56',
    OSPole: 'L56',
    ODPeriphery: 'R57',
    OSPeriphery: 'L57',
    ODOCT: 'R58',
    OSOCT: 'L58',
    Method: 'C31',
    Notes: 'T21',
  },
  Diagnosis: {
    Date: 'T76',
    HealthR1: 'R107',
    HealthR2: 'R156',
    HealthR3: 'R157',
    HealthR4: 'R221',
    HealthR5: 'R222',
    HealthR6: 'R223',
    HealthR7: 'R224',
    HealthR8: 'R225',
    HealthR9: 'R226',
    HealthR10: 'R227',
    RefractionR1: 'R108',
    RefractionR2: 'R228',
    RefractionR3: 'R237',
    BinocularR1: 'R109',
    BinocularR2: 'R229',
    BinocularR3: 'R238',
    RecallR1: 'R110',
    RecallR2: 'R230',
    RecallR3: 'R239',
    HealthL1: 'L107',
    HealthL2: 'L156',
    HealthL3: 'L157',
    HealthL4: 'L221',
    HealthL5: 'L222',
    HealthL6: 'L223',
    HealthL7: 'L224',
    HealthL8: 'L225',
    HealthL9: 'L226',
    HealthL10: 'L227',
    RefractionL1: 'L108',
    RefractionL2: 'L228',
    RefractionL3: 'L237',
    BinocularL1: 'L109',
    BinocularL2: 'L229',
    BinocularL3: 'L238',
    RecallL1: 'L110',
    RecallL2: 'L230',
    RecallL3: 'L239',
    Notes: 'T23',
  },
  OrderRx: {
    ODPD: 'R111',
    OSPD: 'L111',
    ODNPD: 'R112',
    OSNPD: 'L112',
    ODWD: 'R113',
    OSWD: 'L113',
    ODHeight: 'R114',
    OSHeight: 'L114',
    ODBC: 'R115',
    OSBC: 'L115',
  },
  ColorVision: {
    Date: 'T61',
    Test: 'C37',
    Eye: 'C38',
    Diag: 'C39',
    ODDiagnosis: 'R23',
    OSDiagnosis: 'L23',
    Notes: 'T24',
  },
  PosteriorPhoto: {
    Date: 'T77',
    Photos: 'C81',
    ODResults: 'R81',
    OSResults: 'L81',
    Notes: 'D81',
  },
  Binocular: {
    Date: 'T78',
    Bruckner: 'C82',
    RHirschberg: 'R82',
    LHirschberg: 'L82',
  },
  Pupils: {
    Date: 'T57',
    Pupils: 'C41',
    SizeLightOD: 'R117',
    SizeLightOS: 'L117',
    SizeDimOD: 'R118',
    SizeDimOS: 'L118',
    Notes: 'T26',
  },
  Aided: {
    Date: 'T56',
    DxOD: 'R40',
    DxOS: 'L40',
    DxOU: 'B40',
    NxOD: 'R41',
    NxOS: 'L41',
    NxOU: 'B41',
    IxOD: 'R42',
    IxOS: 'L42',
    IxOU: 'B42',
    Method: 'C28',
    RxWorn: 'C29',
    Notes: 'C30',
    PinholeOD1: 'R138',
    PinholeOS1: 'L138',
    PinholeOD2: 'R139',
    PinholeOS2: 'L139',
  },
  Unaided: {
    Date: 'T55',
    DxOD: 'R37',
    DxOS: 'L37',
    DxOU: 'B37',
    NxOD: 'R38',
    NxOS: 'L38',
    NxOU: 'B38',
    IxOD: 'R39',
    IxOS: 'L39',
    IxOU: 'B39',
    Method: 'C27',
    Notes: 'T12',
  },
  Eom: {
    Date: 'T60',
    Eom: 'C40',
    Notes: 'T42',
  },
  Prelims: {
    Date: 'T98',
    Notes: 'C98',
  },
 Drops: {
    Date: 'T66',
    Eye: 'C50',
    Drops: 'C51',
    Time: 'C52',
    Notes: 'D50',
  },
  Retino: {
    Date: 'T64',
    Method: 'C49',
    ODSphere: 'R172',
    OSSphere: 'L172',
    ODCylinder: 'R173',
    OSCylinder: 'L173',
    ODAxis: 'R174',
    OSAxis: 'L174',
    Notes: 'T32',
  },
  Stereopsis: {
    Date: 'T62',
    Stereopsis: 'R116',
    Method: 'L116',
    Notes: 'T25',
  },
  ColorVision2: {
    Date: 'D40',
    Type: 'D37',
    ODPlates: 'D38',
    OSPlates: 'D39',
  },
  Npc: {
    Date: 'D51',
    Npc: 'D47',
    Dominance: 'D48',
    Notes: 'D49',
  },
  CLFinal: {
    Date: 'T72',
    ODSupplier: 'R187',
    OSSupplier: 'L187',
    ODType: 'R188',
    OSType: 'L188',
    ODName: 'R189',
    OSName: 'L189',
    ODColor: 'R190',
    OSColor: 'L190',
    ODPack: 'R237',
    OSPack: 'L237',
    ODBc: 'R195',
    OSBc: 'L195',
    ODDia: 'R196',
    OSDia: 'L196',
    ODSphere: 'R191',
    OSSphere: 'L191',
    ODCylinder: 'R192',
    OSCylinder: 'L192',
    ODAxis: 'R193',
    OSAxis: 'L193',
    ODAdd: 'R194',
    OSAdd: 'L194',
    Status: 'C61',
    ExpiryDate: 'C62',
    FittingNote: 'C63',
    Solution: 'C65',
    Notes: 'C64',
  },
  Habitual: {
    Date: 'T44',
    Lens: 'C72',
    MatteTinted: 'C10',
    ODSphere: 'R10',
    ODCylinder: 'R11',
    ODAxis: 'R12',
    ODAdd: 'R13',
    ODPD: 'R133',
    ODAcuity: 'R76',
    OSSphere: 'L10',
    OSCylinder: 'L11',
    OSAxis: 'L12',
    OSAdd: 'L13',
    OSPD: 'L133',
    OSAcuity: 'L76',
    Method: 'C76',
    OUAcuity: 'C11',
    Notes: 'T11',
    RxDate: 'T111',
    RxExpiry: 'T112',
    ODPrism: 'R14',
    ODOrient: 'R15',
    OSPrism: 'L14',
    OSOrient: 'L15',
    ODPrism2: 'R83',
    ODOrient2: 'R84',
    OSPrism2: 'L83',
    OSOrient2: 'L84',
  },
  Habitual2: {
    Date: 'T45',
    Lens: 'C73',
    MatteTinted: 'C66',
    ODSphere: 'R197',
    ODCylinder: 'R198',
    ODAxis: 'R199',
    ODAdd: 'R200',
    ODPd: 'R134',
    ODAcuity: 'R201',
    OSSphere: 'L197',
    OSCylinder: 'L198',
    OSAxis: 'L199',
    OSAdd: 'L200',
    OSPd: 'L134',
    OSAcuity: 'L201',
    Method: 'C77',
    OUAcuity: 'C67',
    Notes: 'T30',
    RxDate: 'T113',
    RxExpiry: 'T114',
    ODPrism: 'R202',
    ODOrient: 'R203',
    OSPrism: 'L202',
    OSOrient: 'L203',
    ODPrism2: 'R204',
    ODOrient2: 'R205',
    OSPrism2: 'L204',
    OSOrient2: 'L205',
  },
  CLTrial: {
    Date: 'T70',
    ODSupplier: 'R158',
    OSSupplier: 'L158',
    ODType: 'R159',
    OSType: 'L159',
    ODName: 'R160',
    OSName: 'L160',
    ODColor: 'R161',
    OSColor: 'L161',
    ODPack: 'R238',
    OSPack: 'L238',
    ODBc: 'R166',
    OSBc: 'L166',
    ODDia: 'R167',
    OSDia: 'L167',
    ODSphere: 'R162',
    OSSphere: 'L162',
    ODCylinder: 'R163',
    OSCylinder: 'L163',
    ODAxis: 'R164',
    OSAxis: 'L164',
    ODAdd: 'R165',
    OSAdd: 'L165',
    Status: 'C44',
    ExpiryDate: 'C45',
    FittingNote: 'C46',
    Solution: 'C48',
    Notes: 'C47',
  },
  CLTrial2: {
    Date: 'T71',
    ODSupplier: 'R177',
    OSSupplier: 'L177',
    ODType: 'R178',
    OSType: 'L178',
    ODName: 'R179',
    OSName: 'L179',
    ODColor: 'R180',
    OSColor: 'L180',
    ODPack: 'R239',
    OSPack: 'L239',
    ODBc: 'R185',
    OSBc: 'L185',
    ODDia: 'R186',
    OSDia: 'L186',
    ODSphere: 'R181',
    OSSphere: 'L181',
    ODCylinder: 'R182',
    OSCylinder: 'L182',
    ODAxis: 'R183',
    OSAxis: 'L183',
    ODAdd: 'R184',
    OSAdd: 'L184',
    Status: 'C56',
    ExpiryDate: 'C57',
    FittingNote: 'C58',
    Solution: 'C60',
    Notes: 'C59',
  },
  AnteriorCL: {
    Date: 'T73',
    ODCentration: 'R150',
    OSCentration: 'L150',
    ODMovement: 'R151',
    OSMovement: 'L151',
    ODRotation: 'R152',
    OSRotation: 'L152',
    ODCondition: 'R153',
    OSCondition: 'L153',
    ODVisualAcuity: 'R154',
    OSVisualAcuity: 'L154',
    ODPuncta: 'R155',
    OSPuncta: 'L155',
    Notes: 'T29',
  },
  Prescription: {
    Date: 'C100',
    Medication1: 'C101',
    Medication2: 'C102',
    Medication3: 'C103',
    Medication4: 'C104',
    Medication5: 'C105',
    Medication6: 'C106',
    Medication7: 'C107',
    Medication8: 'C108',
    Frequency1: 'C111',
    Frequency2: 'C112',
    Frequency3: 'C113',
    Frequency4: 'C114',
    Frequency5: 'C115',
    Frequency6: 'C116',
    Frequency7: 'C117',
    Frequency8: 'C118',
    Refills1: 'C121',
    Refills2: 'C122',
    Refills3: 'C123',
    Refills4: 'C124',
    Refills5: 'C125',
    Refills6: 'C126',
    Refills7: 'C127',
    Refills8: 'C128',
    Remarks1: 'C131',
    Remarks2: 'C132',
    Remarks3: 'C133',
    Remarks4: 'C134',
    Remarks5: 'C135',
    Remarks6: 'C136',
    Remarks7: 'C137',
    Remarks8: 'C138',
    Check1: 'C141',
    Check2: 'C142',
    Check3: 'C143',
    Check4: 'C144',
    Check5: 'C145',
    Check6: 'C146',
    Check7: 'C147',
    Check8: 'C148',
    Notes: 'C99',
  },
  Medications: {
    Date: 'T74',
    Medication: 'T35',
    Eye: 'T36',
    Frequency: 'T37',
    Mitte: 'T38',
    Refills: 'T39',
    Instructions: 'T40',
    Notes: 'T43',
  },
  MedicationFull: {
    Date: 'T85',
    Type: 'C83',
    Medication: 'C84',
    Mitte: 'C85',
    Dose: 'C86',
    Measure: 'C87',
    Form: 'C88',
    Route: 'C89',
    Duration: 'C90',
    Client: 'C91',
    Pharmacist: 'C92',
  },
  MedsGp: {
    Date: 'D52',
    Medication: 'D53',
    Frequency: 'D54',
    Refills: 'D55',
    SpecialInstructions: 'D56',
    Notes: 'D57',
  },
  Amplitude: {
    Date: 'D71',
    ODAmp: 'R73',
    OSAmp: 'L73',
    ODUnits: 'R74',
    OSUnits: 'L74',
    By: 'D73',
    Notes: 'D72',
  },
  Bcc: {
    Date: 'D77',
    Bcc: 'D74',
    Bpa: 'D75',
    Bma: 'D76',
  },
  Over: {
    Date: 'T123',
    Over: 'T121',
    ODSphere: 'R121',
    OSSphere: 'L121',
    ODCylinder: 'R122',
    OSCylinder: 'L122',
    ODAxis: 'R123',
    OSAxis: 'L123',
    ODAcuity: 'R124',
    OSAcuity: 'L124',
    Notes: 'T122',
  },
  Cycloplegic: {
    Date: 'T51',
    ODSphere: 'R33',
    OSSphere: 'L33',
    ODCylinder: 'R34',
    OSCylinder: 'L34',
    ODAxis: 'R35',
    OSAxis: 'L35',
    ODAcuity: 'R36',
    OSAcuity: 'L36',
    OUAcuity: 'C26',
    Method: 'C25',
    Notes: 'T19',
  },
  ContactLens: {
    Date: 'D41',
    HowLong: 'D42',
    Habits: 'D43',
    ODType: 'D44',
    OSType: 'D45',
    Solution: 'D46',
  },
  Additional: {
    Date: 'T63',
    Hirschberg: 'C53',
    Bruckner: 'C54',
  },
  Pachymetry: {
    Date: 'T87',
    ODThickness: 'R97',
    OSThickness: 'L97',
    ODMmhg: 'R98',
    OSMmhg: 'L98',
    Method: 'D97',
    Notes: 'C97',
  },
  Puncta: {
    Date: 'D10',
    OD: 'R24',
    OS: 'L24',
    Notes: 'T88',
  },
  Gonioscopy: {
    Date: 'T68',
    ODAngles1L: 'R144',
    ODAngles1R: 'R145',
    ODAngles2L: 'R215',
    ODAngles2R: 'R216',
    ODAngles3L: 'R217',
    ODAngles3R: 'R218',
    ODAngles4L: 'R219',
    ODAngles4R: 'R220',
    ODPigment: 'R146',
    ODAnglesRec: 'R147',
    ODNeovascular: 'R148',
    ODApproach: 'R149',
    OSAngles1L: 'L144',
    OSAngles1R: 'L145',
    OSAngles2L: 'L215',
    OSAngles2R: 'L216',
    OSAngles3L: 'L217',
    OSAngles3R: 'L218',
    OSAngles4L: 'L219',
    OSAngles4R: 'L220',
    OSPigment: 'L146',
    OSAnglesRec: 'L147',
    OSNeovascular: 'L148',
    OSApproach: 'L149',
    Notes: 'T28',
  },
  Intake:{
    Existing: 'D79',
    ReasonforVisit: 'D28',
    Symptoms: 'D29',
    Smoker: 'D33',
    Pregnant: 'D62',
    Diabetic: 'D63',
    BloodSugarLevel: 'D35',
    EyeInjury: 'D36',
    EyeSurgery: 'D24',
    MedicalConditions: 'D25',
    CurrentMedications: 'D30',
    Allergies: 'D31',
    FamilyHistory: 'D26',
    InsurerName: 'D85',
    PolicyNumber: 'D86',
    GroupNumber: 'D87',
    RelationtoPolicyholder: 'D88',
    EmergencyContactName: 'D16',
    EmergencyRelationship: 'D17',
    EmergencyContactPhone: 'D18',
    EmergencyAlternativePhone: 'D19',
  }
}

const Complaint = [
  ExamField.Complaint.Date,
  ExamField.Complaint.Primary,
  ExamField.Complaint.Secondary
];

const Ocular = [
  ExamField.Ocular.Date,
  ExamField.Ocular.Family,
  ExamField.Ocular.Client,
  ExamField.Ocular.EyeSurgery,
  ExamField.Ocular.EyeInjury
];

const Medical = [
  ExamField.Medical.Date,
  ExamField.Medical.ClientHistory,
  ExamField.Medical.FamilyHistory,
  ExamField.Medical.Medications,
  ExamField.Medical.Allergies,
  ExamField.Medical.Smoker,
  ExamField.Medical.FamilyDoctor,
  ExamField.Medical.Pregnant,
  ExamField.Medical.WhenDiagnosed,
  ExamField.Medical.Diabetic,
  ExamField.Medical.CurrentBloodSugar
];

const Unaided = [
  ExamField.Unaided.Date,
  ExamField.Unaided.DxOD,
  ExamField.Unaided.DxOS,
  ExamField.Unaided.DxOU,
  ExamField.Unaided.NxOD,
  ExamField.Unaided.NxOS,
  ExamField.Unaided.NxOU,
  ExamField.Unaided.IxOD,
  ExamField.Unaided.IxOS,
  ExamField.Unaided.IxOU,
  ExamField.Unaided.Method,
  ExamField.Unaided.Notes
];

const Aided = [
  ExamField.Aided.Date,
  ExamField.Aided.DxOD,
  ExamField.Aided.DxOS,
  ExamField.Aided.DxOU,
  ExamField.Aided.NxOD,
  ExamField.Aided.NxOS,
  ExamField.Aided.NxOU,
  ExamField.Aided.IxOD,
  ExamField.Aided.IxOS,
  ExamField.Aided.IxOU,
  ExamField.Aided.Method,
  ExamField.Aided.RxWorn,
  ExamField.Aided.Notes
];

const Pupils = [
  ExamField.Pupils.Date,
  ExamField.Pupils.Pupils,
  ExamField.Pupils.SizeLightOD,
  ExamField.Pupils.SizeLightOS,
  ExamField.Pupils.SizeDimOD,
  ExamField.Pupils.SizeDimOS,
  ExamField.Pupils.Notes
];

const Fields = [
  ExamField.Fields.Date,
  ExamField.Fields.Test,
  ExamField.Fields.ODResult,
  ExamField.Fields.OSResult,
  ExamField.Fields.ODReliability,
  ExamField.Fields.OSReliability,
  ExamField.Fields.Notes
];

const CoverTest = [
  ExamField.CoverTest.Date,
  ExamField.CoverTest.DxStrab,
  ExamField.CoverTest.DxSide,
  ExamField.CoverTest.DxRate,
  ExamField.CoverTest.DxDeviation,
  ExamField.CoverTest.DxDirection,
  ExamField.CoverTest.NxStrab,
  ExamField.CoverTest.NxSide,
  ExamField.CoverTest.NxRate,
  ExamField.CoverTest.NxDeviation,
  ExamField.CoverTest.NxDirection,
  ExamField.CoverTest.Notes
];

const ColorVision = [
  ExamField.ColorVision.Date,
  ExamField.ColorVision.Test,
  ExamField.ColorVision.Eye,
  ExamField.ColorVision.Diag,
  ExamField.ColorVision.ODDiagnosis,
  ExamField.ColorVision.OSDiagnosis,
  ExamField.ColorVision.Notes,
];


const ColorVision2 = [
  ExamField.ColorVision2.Date,
  ExamField.ColorVision2.Type,
  ExamField.ColorVision2.ODPlates,
  ExamField.ColorVision2.OSPlates
];

const Stereopsis = [
  ExamField.Stereopsis.Date,
  ExamField.Stereopsis.Stereopsis,
  ExamField.Stereopsis.Method,
  ExamField.Stereopsis.Notes,
];

const Additional = [
  ExamField.Additional.Date,
  ExamField.Additional.Hirschberg,
  ExamField.Additional.Bruckner,
];

const Binocular = [
  ExamField.Binocular.Date,
  ExamField.Binocular.RHirschberg,
  ExamField.Binocular.LHirschberg,
  ExamField.Binocular.Bruckner
];

const Retino = [
  ExamField.Retino.Date,
  ExamField.Retino.Method,
  ExamField.Retino.ODSphere,
  ExamField.Retino.ODCylinder,
  ExamField.Retino.ODAxis,
  ExamField.Retino.OSSphere,
  ExamField.Retino.OSCylinder,
  ExamField.Retino.OSAxis,
  ExamField.Retino.Notes
];

const Amplitude = [
  ExamField.Amplitude.Date,
  ExamField.Amplitude.ODAmp,
  ExamField.Amplitude.ODUnits,
  ExamField.Amplitude.OSAmp,
  ExamField.Amplitude.OSUnits,
  ExamField.Amplitude.By,
  ExamField.Amplitude.Notes
];

const Drops = [
  ExamField.Drops.Date,
  ExamField.Drops.Eye,
  ExamField.Drops.Drops,
  ExamField.Drops.Time,
  ExamField.Drops.Notes
];

const Anterior = [
  ExamField.Anterior.Date,
  ExamField.Anterior.ODAdnexa,
  ExamField.Anterior.OSAdnexa,
  ExamField.Anterior.ODLidsLashes,
  ExamField.Anterior.OSLidsLashes,
  ExamField.Anterior.ODPalpebral,
  ExamField.Anterior.OSPalpebral,
  ExamField.Anterior.ODConjunctiva,
  ExamField.Anterior.OSConjunctiva,
  ExamField.Anterior.ODCornea,
  ExamField.Anterior.OSCornea,
  ExamField.Anterior.ODAngles,
  ExamField.Anterior.OSAngles,
  ExamField.Anterior.ODChamber,
  ExamField.Anterior.OSChamber,
  ExamField.Anterior.ODIris,
  ExamField.Anterior.OSIris,
  ExamField.Anterior.ODLens,
  ExamField.Anterior.OSLens,
  ExamField.Anterior.ODVitreous,
  ExamField.Anterior.OSVitreous,
  ExamField.Anterior.ODPuncta,
  ExamField.Anterior.OSPuncta,
  ExamField.Anterior.Notes
];

const Puncta = [
  ExamField.Puncta.Date,
  ExamField.Puncta.OD,
  ExamField.Puncta.OS,
  ExamField.Puncta.Notes
];

const Posterior = [
  ExamField.Posterior.Date,
  ExamField.Posterior.ODCDRatio,
  ExamField.Posterior.OSCDRatio,
  ExamField.Posterior.ODOpticNerveHead,
  ExamField.Posterior.OSOpticNerveHead,
  ExamField.Posterior.ODMacula,
  ExamField.Posterior.OSMacula,
  ExamField.Posterior.ODVasculature,
  ExamField.Posterior.OSVasculature,
  ExamField.Posterior.ODPole,
  ExamField.Posterior.OSPole,
  ExamField.Posterior.ODPeriphery,
  ExamField.Posterior.OSPeriphery,
  ExamField.Posterior.Method,
  ExamField.Posterior.ODOCT,
  ExamField.Posterior.OSOCT,
  ExamField.Posterior.Notes
];

const Gonioscopy = [
  ExamField.Gonioscopy.Date,
  ExamField.Gonioscopy.ODAngles1L,
  ExamField.Gonioscopy.ODAngles1R,
  ExamField.Gonioscopy.OSAngles1L,
  ExamField.Gonioscopy.OSAngles1R,
  ExamField.Gonioscopy.ODAngles2L,
  ExamField.Gonioscopy.ODAngles2R,
  ExamField.Gonioscopy.OSAngles2L,
  ExamField.Gonioscopy.OSAngles2R,
  ExamField.Gonioscopy.ODAngles3L,
  ExamField.Gonioscopy.ODAngles3R,
  ExamField.Gonioscopy.OSAngles3L,
  ExamField.Gonioscopy.OSAngles3R,
  ExamField.Gonioscopy.ODAngles4L,
  ExamField.Gonioscopy.ODAngles4R,
  ExamField.Gonioscopy.OSAngles4L,
  ExamField.Gonioscopy.OSAngles4R,
  ExamField.Gonioscopy.ODPigment,
  ExamField.Gonioscopy.OSPigment,
  ExamField.Gonioscopy.ODAnglesRec,
  ExamField.Gonioscopy.OSAnglesRec,
  ExamField.Gonioscopy.ODNeovascular,
  ExamField.Gonioscopy.OSNeovascular,
  ExamField.Gonioscopy.ODApproach,
  ExamField.Gonioscopy.OSApproach,
  ExamField.Gonioscopy.Notes
];

const Fields2 = [
  ExamField.Fields2.Date,
  ExamField.Fields2.Test,
  ExamField.Fields2.ODResult,
  ExamField.Fields2.OSResult,
  ExamField.Fields2.ODReliability,
  ExamField.Fields2.OSReliability,
  ExamField.Fields2.Notes
];

const Prescription = [
  ExamField.Prescription.Date,
  ExamField.Prescription.Medication1,
  ExamField.Prescription.Frequency1,
  ExamField.Prescription.Refills1,
  ExamField.Prescription.Remarks1,
  ExamField.Prescription.Medication2,
  ExamField.Prescription.Frequency2,
  ExamField.Prescription.Refills2,
  ExamField.Prescription.Remarks2,
  ExamField.Prescription.Medication3,
  ExamField.Prescription.Frequency3,
  ExamField.Prescription.Refills3,
  ExamField.Prescription.Remarks3,
  ExamField.Prescription.Medication4,
  ExamField.Prescription.Frequency4,
  ExamField.Prescription.Refills4,
  ExamField.Prescription.Remarks4,
  ExamField.Prescription.Medication5,
  ExamField.Prescription.Frequency5,
  ExamField.Prescription.Refills5,
  ExamField.Prescription.Remarks5,
  ExamField.Prescription.Medication6,
  ExamField.Prescription.Frequency6,
  ExamField.Prescription.Refills6,
  ExamField.Prescription.Remarks6,
  ExamField.Prescription.Medication7,
  ExamField.Prescription.Frequency7,
  ExamField.Prescription.Refills7,
  ExamField.Prescription.Remarks7,
  ExamField.Prescription.Medication8,
  ExamField.Prescription.Frequency8,
  ExamField.Prescription.Refills8,
  ExamField.Prescription.Remarks8,
  ExamField.Prescription.Notes
];

const Medications = [
  ExamField.Medications.Date,
  ExamField.Medications.Medication,
  ExamField.Medications.Eye,
  ExamField.Medications.Frequency,
  ExamField.Medications.Mitte,
  ExamField.Medications.Refills,
  ExamField.Medications.Instructions,
  ExamField.Medications.Notes
];

const MedicationFull = [
  ExamField.MedicationFull.Date,
  ExamField.MedicationFull.Type,
  ExamField.MedicationFull.Medication,
  ExamField.MedicationFull.Mitte,
  ExamField.MedicationFull.Dose,
  ExamField.MedicationFull.Measure,
  ExamField.MedicationFull.Form,
  ExamField.MedicationFull.Route,
  ExamField.MedicationFull.Duration,
  ExamField.MedicationFull.Client,
  ExamField.MedicationFull.Pharmacist
];

const Diagnosis = [
  ExamField.Diagnosis.Date,
  ExamField.Diagnosis.HealthR1,
  ExamField.Diagnosis.HealthL1,
  ExamField.Diagnosis.HealthR2,
  ExamField.Diagnosis.HealthL2,
  ExamField.Diagnosis.HealthR3,
  ExamField.Diagnosis.HealthL3,
  ExamField.Diagnosis.HealthR4,
  ExamField.Diagnosis.HealthL4,
  ExamField.Diagnosis.HealthR5,
  ExamField.Diagnosis.HealthL5,
  ExamField.Diagnosis.HealthR6,
  ExamField.Diagnosis.HealthL6,
  ExamField.Diagnosis.HealthR7,
  ExamField.Diagnosis.HealthL7,
  ExamField.Diagnosis.HealthR8,
  ExamField.Diagnosis.HealthL8,
  ExamField.Diagnosis.HealthR9,
  ExamField.Diagnosis.HealthL9,
  ExamField.Diagnosis.HealthR10,
  ExamField.Diagnosis.HealthL10,
  ExamField.Diagnosis.RefractionR1,
  ExamField.Diagnosis.RefractionL1,
  ExamField.Diagnosis.RefractionR2,
  ExamField.Diagnosis.RefractionL2,
  ExamField.Diagnosis.BinocularR1,
  ExamField.Diagnosis.BinocularL1,
  ExamField.Diagnosis.BinocularR2,
  ExamField.Diagnosis.BinocularL2,
  ExamField.Diagnosis.RecallR1,
  ExamField.Diagnosis.RecallL1,
  ExamField.Diagnosis.RecallR2,
  ExamField.Diagnosis.RecallL2,
  ExamField.Diagnosis.Notes
];

const Habitual = [
  ExamField.Habitual.Date,
  ExamField.Habitual.Lens,
  ExamField.Habitual.MatteTinted,
  ExamField.Habitual.ODSphere,
  ExamField.Habitual.ODCylinder,
  ExamField.Habitual.ODAxis,
  ExamField.Habitual.ODAdd,
  ExamField.Habitual.ODPD,
  ExamField.Habitual.ODAcuity,
  ExamField.Habitual.OSSphere,
  ExamField.Habitual.OSCylinder,
  ExamField.Habitual.OSAxis,
  ExamField.Habitual.OSAdd,
  ExamField.Habitual.OSPD,
  ExamField.Habitual.OSAcuity,
  ExamField.Habitual.Method,
  ExamField.Habitual.OUAcuity,
  ExamField.Habitual.Notes,
  ExamField.Habitual.RxDate,
  ExamField.Habitual.RxExpiry,
  ExamField.Habitual.ODPrism,
  ExamField.Habitual.ODOrient,
  ExamField.Habitual.ODPrism2,
  ExamField.Habitual.ODOrient2,
  ExamField.Habitual.OSPrism,
  ExamField.Habitual.OSOrient,
  ExamField.Habitual.OSPrism2,
  ExamField.Habitual.OSOrient2
];

const Habitual2 = [
  ExamField.Habitual2.Date,
  ExamField.Habitual2.Lens,
  ExamField.Habitual2.MatteTinted,
  ExamField.Habitual2.ODSphere,
  ExamField.Habitual2.ODCylinder,
  ExamField.Habitual2.ODAxis,
  ExamField.Habitual2.ODAdd,
  ExamField.Habitual2.ODPd,
  ExamField.Habitual2.ODAcuity,
  ExamField.Habitual2.OSSphere,
  ExamField.Habitual2.OSCylinder,
  ExamField.Habitual2.OSAxis,
  ExamField.Habitual2.OSAdd,
  ExamField.Habitual2.OSPd,
  ExamField.Habitual2.OSAcuity,
  ExamField.Habitual2.Method,
  ExamField.Habitual2.OUAcuity,
  ExamField.Habitual2.Notes,
  ExamField.Habitual2.RxDate,
  ExamField.Habitual2.RxExpiry,
  ExamField.Habitual2.ODPrism,
  ExamField.Habitual2.ODOrient,
  ExamField.Habitual2.ODPrism2,
  ExamField.Habitual2.ODOrient2,
  ExamField.Habitual2.OSPrism,
  ExamField.Habitual2.OSOrient,
  ExamField.Habitual2.OSPrism2,
  ExamField.Habitual2.OSOrient2,
];

const Tonometry = [
  ExamField.Tonometry.Date,
  ExamField.Tonometry.ODIOP,
  ExamField.Tonometry.OSIOP,
  ExamField.Tonometry.ODIOP2,
  ExamField.Tonometry.OSIOP2,
  ExamField.Tonometry.ODIOP3,
  ExamField.Tonometry.OSIOP3,
  ExamField.Tonometry.Time,
  ExamField.Tonometry.Method,
  ExamField.Tonometry.Notes
];

const Tonometry2 = [
  ExamField.Tonometry2.Date,
  ExamField.Tonometry2.ODIOP,
  ExamField.Tonometry2.OSIOP,
  ExamField.Tonometry2.ODIOP2,
  ExamField.Tonometry2.OSIOP2,
  ExamField.Tonometry2.ODIOP3,
  ExamField.Tonometry2.OSIOP3,
  ExamField.Tonometry2.Time,
  ExamField.Tonometry2.Method,
  ExamField.Tonometry2.Notes
];

const Over = [
  ExamField.Over.Date,
  ExamField.Over.Over,
  ExamField.Over.ODSphere,
  ExamField.Over.ODCylinder,
  ExamField.Over.ODAxis,
  ExamField.Over.ODAcuity,
  ExamField.Over.OSSphere,
  ExamField.Over.OSCylinder,
  ExamField.Over.OSAxis,
  ExamField.Over.OSAcuity,
  ExamField.Over.Notes
];

const Keratom = [
  ExamField.Keratom.Date,
  ExamField.Keratom.ODHoriz,
  ExamField.Keratom.ODAxis,
  ExamField.Keratom.ODVert,
  ExamField.Keratom.OSHoriz,
  ExamField.Keratom.OSAxis,
  ExamField.Keratom.OSVert,
  ExamField.Keratom.ODHoriz2,
  ExamField.Keratom.ODAxis2,
  ExamField.Keratom.ODVert2,
  ExamField.Keratom.OSHoriz2,
  ExamField.Keratom.OSAxis2,
  ExamField.Keratom.OSVert2,
  ExamField.Keratom.Method,
];

const Pachymetry = [
  ExamField.Pachymetry.Date,
  ExamField.Pachymetry.ODThickness,
  ExamField.Pachymetry.ODMmhg,
  ExamField.Pachymetry.OSThickness,
  ExamField.Pachymetry.OSMmhg,
];

const Autorefraction = [
  ExamField.Autorefraction.Date,
  ExamField.Autorefraction.ODSphere,
  ExamField.Autorefraction.ODCylinder,
  ExamField.Autorefraction.ODAxis,
  ExamField.Autorefraction.ODAcuity,
  ExamField.Autorefraction.OSSphere,
  ExamField.Autorefraction.OSCylinder,
  ExamField.Autorefraction.OSAxis,
  ExamField.Autorefraction.OSAcuity,
  ExamField.Autorefraction.Method,
  ExamField.Autorefraction.Notes,
];

const Subjective = [
  ExamField.Subjective.Date,
  ExamField.Subjective.ODSphere,
  ExamField.Subjective.ODCylinder,
  ExamField.Subjective.ODAxis,
  ExamField.Subjective.ODAcuity,
  ExamField.Subjective.OSSphere,
  ExamField.Subjective.OSCylinder,
  ExamField.Subjective.OSAxis,
  ExamField.Subjective.OSAcuity,
  ExamField.Subjective.Method,
  ExamField.Subjective.OUAcuity,
  ExamField.Subjective.Notes,
  ExamField.Subjective.ODPrism,
  ExamField.Subjective.ODOrient,
  ExamField.Subjective.ODPrism2,
  ExamField.Subjective.ODOrient2,
  ExamField.Subjective.OSPrism,
  ExamField.Subjective.OSOrient,
  ExamField.Subjective.OSPrism2,
  ExamField.Subjective.OSOrient2
];

const FinalAdd = [
  ExamField.FinalAdd.Date,
  ExamField.FinalAdd.WorkingDistance,
  ExamField.FinalAdd.ODFinalAdd,
  ExamField.FinalAdd.ODAcuity,
  ExamField.FinalAdd.OSFinalAdd,
  ExamField.FinalAdd.OSAcuity,
  ExamField.FinalAdd.OUAcuity,
  ExamField.FinalAdd.Notes
];

const Balance = [
  ExamField.Balance.Date,
  ExamField.Balance.ODSphere,
  ExamField.Balance.ODCylinder,
  ExamField.Balance.ODAxis,
  ExamField.Balance.ODAcuity,
  ExamField.Balance.OSSphere,
  ExamField.Balance.OSCylinder,
  ExamField.Balance.OSAxis,
  ExamField.Balance.OSAcuity,
  ExamField.Balance.Method,
  ExamField.Balance.OUAcuity,
  ExamField.Balance.Notes,
  ExamField.Balance.ODPrism,
  ExamField.Balance.ODOrient,
  ExamField.Balance.ODPrism2,
  ExamField.Balance.ODOrient2,
  ExamField.Balance.OSPrism,
  ExamField.Balance.OSOrient,
  ExamField.Balance.OSPrism2,
  ExamField.Balance.OSOrient2
];

const FinalRx = [
  ExamField.FinalRx.Date,
  ExamField.FinalRx.Lens,
  ExamField.FinalRx.MatteTinted,
  ExamField.FinalRx.ODSphere,
  ExamField.FinalRx.ODCylinder,
  ExamField.FinalRx.ODAxis,
  ExamField.FinalRx.ODAdd,
  ExamField.FinalRx.ODPd,
  ExamField.FinalRx.ODAcuity,
  ExamField.FinalRx.OSSphere,
  ExamField.FinalRx.OSCylinder,
  ExamField.FinalRx.OSAxis,
  ExamField.FinalRx.OSAdd,
  ExamField.FinalRx.OSPd,
  ExamField.FinalRx.OSAcuity,
  ExamField.FinalRx.Method,
  ExamField.FinalRx.OUAcuity,
  ExamField.FinalRx.Notes,
  ExamField.FinalRx.RxDate,
  ExamField.FinalRx.RxExpiry,
  ExamField.FinalRx.ODPrism,
  ExamField.FinalRx.ODOrient,
  ExamField.FinalRx.ODPrism2,
  ExamField.FinalRx.ODOrient2,
  ExamField.FinalRx.OSPrism,
  ExamField.FinalRx.OSOrient,
  ExamField.FinalRx.OSPrism2,
  ExamField.FinalRx.OSOrient2
];

const FinalRx2 = [
  ExamField.FinalRx2.Date,
  ExamField.FinalRx2.Lens,
  ExamField.FinalRx2.MatteTinted,
  ExamField.FinalRx2.ODSphere,
  ExamField.FinalRx2.ODCylinder,
  ExamField.FinalRx2.ODAxis,
  ExamField.FinalRx2.ODAdd,
  ExamField.FinalRx2.ODPd,
  ExamField.FinalRx2.ODAcuity,
  ExamField.FinalRx2.OSSphere,
  ExamField.FinalRx2.OSCylinder,
  ExamField.FinalRx2.OSAxis,
  ExamField.FinalRx2.OSAdd,
  ExamField.FinalRx2.OSPd,
  ExamField.FinalRx2.OSAcuity,
  ExamField.FinalRx2.Method,
  ExamField.FinalRx2.OUAcuity,
  ExamField.FinalRx2.Notes,
  ExamField.FinalRx2.RxDate,
  ExamField.FinalRx2.RxExpiry,
  ExamField.FinalRx2.ODPrism,
  ExamField.FinalRx2.ODOrient,
  ExamField.FinalRx2.ODPrism2,
  ExamField.FinalRx2.ODOrient2,
  ExamField.FinalRx2.OSPrism,
  ExamField.FinalRx2.OSOrient,
  ExamField.FinalRx2.OSPrism2,
  ExamField.FinalRx2.OSOrient2
];

const Cycloplegic = [
  ExamField.Cycloplegic.Date,
  ExamField.Cycloplegic.ODSphere,
  ExamField.Cycloplegic.ODCylinder,
  ExamField.Cycloplegic.ODAxis,
  ExamField.Cycloplegic.ODAcuity,
  ExamField.Cycloplegic.OSSphere,
  ExamField.Cycloplegic.OSCylinder,
  ExamField.Cycloplegic.OSAxis,
  ExamField.Cycloplegic.OSAcuity,
  ExamField.Cycloplegic.Method,
  ExamField.Cycloplegic.OUAcuity,
  ExamField.Cycloplegic.Notes,
];

const Pd = [
  ExamField.Pd.Date,
  ExamField.Pd.DxOD,
  ExamField.Pd.DxOS,
  ExamField.Pd.DxOU,
  ExamField.Pd.NxOD,
  ExamField.Pd.NxOS,
  ExamField.Pd.NxOU,
  ExamField.Pd.Notes
];

const Other = [
  ExamField.Other.Date,
  ExamField.Other.DxOD,
  ExamField.Other.DxOS,
  ExamField.Other.DxOU,
  ExamField.Other.NxOD,
  ExamField.Other.NxOS,
  ExamField.Other.NxOU,
  ExamField.Other.Notes
];

const CLTrial = [
  ExamField.CLTrial.Date,  
  ExamField.CLTrial.Status,  
  ExamField.CLTrial.ODSupplier,  
  ExamField.CLTrial.ODType, 
  ExamField.CLTrial.ODName,  
  ExamField.CLTrial.ODColor,  
  ExamField.CLTrial.OSSupplier,  
  ExamField.CLTrial.OSType,  
  ExamField.CLTrial.OSName,  
  ExamField.CLTrial.OSColor,  
  ExamField.CLTrial.ODBc,  
  ExamField.CLTrial.ODDia,  
  ExamField.CLTrial.ODSphere,  
  ExamField.CLTrial.ODCylinder,  
  ExamField.CLTrial.ODAxis,  
  ExamField.CLTrial.ODAdd,  
  ExamField.CLTrial.OSBc,  
  ExamField.CLTrial.OSDia,  
  ExamField.CLTrial.OSSphere,  
  ExamField.CLTrial.OSCylinder,  
  ExamField.CLTrial.OSAxis,  
  ExamField.CLTrial.OSAdd,  
  ExamField.CLTrial.ExpiryDate,  
  ExamField.CLTrial.FittingNote,  
  ExamField.CLTrial.Notes,  
  ExamField.CLTrial.Solution,  
];

const CLTrial2 = [	 
  ExamField.CLTrial2.Date,  
  ExamField.CLTrial2.Status,  
  ExamField.CLTrial2.ODSupplier,  
  ExamField.CLTrial2.ODType,  
  ExamField.CLTrial2.ODName,  
  ExamField.CLTrial2.ODColor,  
  ExamField.CLTrial2.OSSupplier,  
  ExamField.CLTrial2.OSType,  
  ExamField.CLTrial2.OSName,  
  ExamField.CLTrial2.OSColor,  
  ExamField.CLTrial2.ODBc,  
  ExamField.CLTrial2.ODDia,  
  ExamField.CLTrial2.ODSphere, 
  ExamField.CLTrial2.ODCylinder,  
  ExamField.CLTrial2.ODAxis,  
  ExamField.CLTrial2.ODAdd,  
  ExamField.CLTrial2.OSBc,  
  ExamField.CLTrial2.OSDia,  
  ExamField.CLTrial2.OSSphere,  
  ExamField.CLTrial2.OSCylinder,  
  ExamField.CLTrial2.OSAxis,  
  ExamField.CLTrial2.OSAdd,  
  ExamField.CLTrial2.ExpiryDate,  
  ExamField.CLTrial2.FittingNote,  
  ExamField.CLTrial2.Notes,  
  ExamField.CLTrial2.Solution  
];

const CLFinal = [
  ExamField.CLFinal.Date,
  ExamField.CLFinal.Status,
  ExamField.CLFinal.ODSupplier,
  ExamField.CLFinal.ODType,
  ExamField.CLFinal.ODName,
  ExamField.CLFinal.ODColor,
  ExamField.CLFinal.OSSupplier,
  ExamField.CLFinal.OSType,
  ExamField.CLFinal.OSName,
  ExamField.CLFinal.OSColor,
  ExamField.CLFinal.ODBc,
  ExamField.CLFinal.ODDia,
  ExamField.CLFinal.ODSphere,
  ExamField.CLFinal.ODCylinder,
  ExamField.CLFinal.ODAxis,
  ExamField.CLFinal.ODAdd,
  ExamField.CLFinal.OSBc,
  ExamField.CLFinal.OSDia,
  ExamField.CLFinal.OSSphere,
  ExamField.CLFinal.OSCylinder,
  ExamField.CLFinal.OSAxis,
  ExamField.CLFinal.OSAdd,
  ExamField.CLFinal.ExpiryDate,
  ExamField.CLFinal.FittingNote,
  ExamField.CLFinal.Notes,
  ExamField.CLFinal.Solution
];

const AnteriorCL = [
  ExamField.AnteriorCL.Date,
  ExamField.AnteriorCL.ODCentration,
  ExamField.AnteriorCL.OSCentration,
  ExamField.AnteriorCL.ODMovement,
  ExamField.AnteriorCL.OSMovement,
  ExamField.AnteriorCL.ODRotation,
  ExamField.AnteriorCL.OSRotation,
  ExamField.AnteriorCL.ODCondition,
  ExamField.AnteriorCL.OSCondition,
  ExamField.AnteriorCL.ODVisualAcuity,
  ExamField.AnteriorCL.OSVisualAcuity,
  ExamField.AnteriorCL.ODPuncta,
  ExamField.AnteriorCL.OSPuncta,
  ExamField.AnteriorCL.Notes
];

const ContactLens = [
  ExamField.ContactLens.Date,
  ExamField.ContactLens.HowLong,
  ExamField.ContactLens.Habits,
  ExamField.ContactLens.ODType,
  ExamField.ContactLens.OSType,
  ExamField.ContactLens.Solution
];

const PosteriorPhoto = [
  ExamField.PosteriorPhoto.Date,
  ExamField.PosteriorPhoto.Photos,
  ExamField.PosteriorPhoto.ODResults,
  ExamField.PosteriorPhoto.OSResults,
  ExamField.PosteriorPhoto.Notes
];

const Eom = [
  ExamField.Eom.Date,
  ExamField.Eom.Eom,
  ExamField.Eom.Notes
];

const Prelims = [
  ExamField.Prelims.Date,
  ExamField.Prelims.Notes
];

const Npc = [
  ExamField.Npc.Date,
  ExamField.Npc.Npc,
  ExamField.Npc.Dominance,
  ExamField.Npc.Notes
];

const Bcc = [
  ExamField.Bcc.Date,
  ExamField.Bcc.Bcc,
  ExamField.Bcc.Bpa,
  ExamField.Bcc.Bma
];

const AllFields = [
  ExamField.Complaint.Primary,
  ExamField.Complaint.Secondary,
  ExamField.Ocular.Family,
  ExamField.Ocular.Client,
  ExamField.Ocular.EyeSurgery,
  ExamField.Medical.ClientHistory,
  ExamField.Medical.FamilyHistory,
  ExamField.Medical.Medications,
  ExamField.Medical.Allergies,
  ExamField.Medical.Smoker,
  ExamField.Medical.FamilyDoctor,
  ExamField.Medical.Pregnant,
  ExamField.Medical.WhenDiagnosed,
  ExamField.Medical.Diabetic,
  ExamField.Medical.CurrentBloodSugar,
  ExamField.Unaided.DxOD,
  ExamField.Unaided.DxOS,
  ExamField.Unaided.DxOU,
  ExamField.Unaided.NxOD,
  ExamField.Unaided.NxOS,
  ExamField.Unaided.NxOU,
  ExamField.Unaided.IxOD,
  ExamField.Unaided.IxOS,
  ExamField.Unaided.IxOU,
  ExamField.Unaided.Method,
  ExamField.Unaided.Notes,
  ExamField.Aided.DxOD,
  ExamField.Aided.DxOS,
  ExamField.Aided.DxOU,
  ExamField.Aided.NxOD,
  ExamField.Aided.NxOS,
  ExamField.Aided.NxOU,
  ExamField.Aided.IxOD,
  ExamField.Aided.IxOS,
  ExamField.Aided.IxOU,
  ExamField.Aided.Method,
  ExamField.Aided.RxWorn,
  ExamField.Aided.Notes,
  ExamField.Pupils.Pupils,
  ExamField.Pupils.SizeLightOD,
  ExamField.Pupils.SizeLightOS,
  ExamField.Pupils.SizeDimOD,
  ExamField.Pupils.SizeDimOS,
  ExamField.Pupils.Notes,
  ExamField.Fields.Test,
  ExamField.Fields.ODResult,
  ExamField.Fields.OSResult,
  ExamField.Fields.ODReliability,
  ExamField.Fields.OSReliability,
  ExamField.Fields.Notes,
  ExamField.CoverTest.DxStrab,
  ExamField.CoverTest.DxSide,
  ExamField.CoverTest.DxRate,
  ExamField.CoverTest.DxDeviation,
  ExamField.CoverTest.DxDirection,
  ExamField.CoverTest.NxStrab,
  ExamField.CoverTest.NxSide,
  ExamField.CoverTest.NxRate,
  ExamField.CoverTest.NxDeviation,
  ExamField.CoverTest.NxDirection,
  ExamField.CoverTest.Notes,
  ExamField.ColorVision.Test,
  ExamField.ColorVision.Eye,
  ExamField.ColorVision.Diag,
  ExamField.ColorVision.ODDiagnosis,
  ExamField.ColorVision.OSDiagnosis,
  ExamField.ColorVision.Notes,
  ExamField.ColorVision2.Type,
  ExamField.ColorVision2.ODPlates,
  ExamField.ColorVision2.OSPlates,
  ExamField.Stereopsis.Stereopsis,
  ExamField.Stereopsis.Method,
  ExamField.Stereopsis.Notes,
  ExamField.Additional.Hirschberg,
  ExamField.Additional.Bruckner,
  ExamField.Binocular.RHirschberg,
  ExamField.Binocular.LHirschberg,
  ExamField.Binocular.Bruckner,
  ExamField.Retino.Method,
  ExamField.Retino.ODSphere,
  ExamField.Retino.ODCylinder,
  ExamField.Retino.ODAxis,
  ExamField.Retino.OSSphere,
  ExamField.Retino.OSCylinder,
  ExamField.Retino.OSAxis,
  ExamField.Retino.Notes,
  ExamField.Amplitude.ODAmp,
  ExamField.Amplitude.ODUnits,
  ExamField.Amplitude.OSAmp,
  ExamField.Amplitude.OSUnits,
  ExamField.Amplitude.By,
  ExamField.Amplitude.Notes,
  ExamField.Drops.Eye,
  ExamField.Drops.Drops,
  ExamField.Drops.Time,
  ExamField.Drops.Notes,
  ExamField.Anterior.ODAdnexa,
  ExamField.Anterior.OSAdnexa,
  ExamField.Anterior.ODLidsLashes,
  ExamField.Anterior.OSLidsLashes,
  ExamField.Anterior.ODPalpebral,
  ExamField.Anterior.OSPalpebral,
  ExamField.Anterior.ODConjunctiva,
  ExamField.Anterior.OSConjunctiva,
  ExamField.Anterior.ODCornea,
  ExamField.Anterior.OSCornea,
  ExamField.Anterior.ODAngles,
  ExamField.Anterior.OSAngles,
  ExamField.Anterior.ODChamber,
  ExamField.Anterior.OSChamber,
  ExamField.Anterior.ODIris,
  ExamField.Anterior.OSIris,
  ExamField.Anterior.ODLens,
  ExamField.Anterior.OSLens,
  ExamField.Anterior.ODVitreous,
  ExamField.Anterior.OSVitreous,
  ExamField.Anterior.ODPuncta,
  ExamField.Anterior.OSPuncta,
  ExamField.Puncta.OD,
  ExamField.Puncta.OS,
  ExamField.Posterior.ODCDRatio,
  ExamField.Posterior.OSCDRatio,
  ExamField.Posterior.ODOpticNerveHead,
  ExamField.Posterior.OSOpticNerveHead,
  ExamField.Posterior.ODMacula,
  ExamField.Posterior.OSMacula,
  ExamField.Posterior.ODVasculature,
  ExamField.Posterior.OSVasculature,
  ExamField.Posterior.ODPole,
  ExamField.Posterior.OSPole,
  ExamField.Posterior.ODPeriphery,
  ExamField.Posterior.OSPeriphery,
  ExamField.Posterior.Method,
  ExamField.Posterior.ODOCT,
  ExamField.Posterior.OSOCT,
  ExamField.Posterior.Notes,
  ExamField.Gonioscopy.ODAngles1L,
  ExamField.Gonioscopy.ODAngles1R,
  ExamField.Gonioscopy.OSAngles1L,
  ExamField.Gonioscopy.OSAngles1R,
  ExamField.Gonioscopy.ODAngles2L,
  ExamField.Gonioscopy.ODAngles2R,
  ExamField.Gonioscopy.OSAngles2L,
  ExamField.Gonioscopy.OSAngles2R,
  ExamField.Gonioscopy.ODAngles3L,
  ExamField.Gonioscopy.ODAngles3R,
  ExamField.Gonioscopy.OSAngles3L,
  ExamField.Gonioscopy.OSAngles3R,
  ExamField.Gonioscopy.ODAngles4L,
  ExamField.Gonioscopy.ODAngles4R,
  ExamField.Gonioscopy.OSAngles4L,
  ExamField.Gonioscopy.OSAngles4R,
  ExamField.Gonioscopy.ODPigment,
  ExamField.Gonioscopy.OSPigment,
  ExamField.Gonioscopy.ODAnglesRec,
  ExamField.Gonioscopy.OSAnglesRec,
  ExamField.Gonioscopy.ODNeovascular,
  ExamField.Gonioscopy.OSNeovascular,
  ExamField.Gonioscopy.ODApproach,
  ExamField.Gonioscopy.OSApproach,
  ExamField.Gonioscopy.Notes,
  ExamField.Fields2.Test,
  ExamField.Fields2.ODResult,
  ExamField.Fields2.OSResult,
  ExamField.Fields2.ODReliability,
  ExamField.Fields2.OSReliability,
  ExamField.Fields2.Notes,
  ExamField.Prescription.Medication1,
  ExamField.Prescription.Frequency1,
  ExamField.Prescription.Refills1,
  ExamField.Prescription.Remarks1,
  ExamField.Prescription.Medication2,
  ExamField.Prescription.Frequency2,
  ExamField.Prescription.Refills2,
  ExamField.Prescription.Remarks2,
  ExamField.Prescription.Medication3,
  ExamField.Prescription.Frequency3,
  ExamField.Prescription.Refills3,
  ExamField.Prescription.Remarks3,
  ExamField.Prescription.Medication4,
  ExamField.Prescription.Frequency4,
  ExamField.Prescription.Refills4,
  ExamField.Prescription.Remarks4,
  ExamField.Prescription.Medication5,
  ExamField.Prescription.Frequency5,
  ExamField.Prescription.Refills5,
  ExamField.Prescription.Remarks5,
  ExamField.Prescription.Medication6,
  ExamField.Prescription.Frequency6,
  ExamField.Prescription.Refills6,
  ExamField.Prescription.Remarks6,
  ExamField.Prescription.Medication7,
  ExamField.Prescription.Frequency7,
  ExamField.Prescription.Refills7,
  ExamField.Prescription.Remarks7,
  ExamField.Prescription.Medication8,
  ExamField.Prescription.Frequency8,
  ExamField.Prescription.Refills8,
  ExamField.Prescription.Remarks8,
  ExamField.Prescription.Notes,
  ExamField.Medications.Medication,
  ExamField.Medications.Eye,
  ExamField.Medications.Frequency,
  ExamField.Medications.Mitte,
  ExamField.Medications.Refills,
  ExamField.Medications.Instructions,
  ExamField.Medications.Notes,
  ExamField.MedicationFull.Type,
  ExamField.MedicationFull.Medication,
  ExamField.MedicationFull.Mitte,
  ExamField.MedicationFull.Dose,
  ExamField.MedicationFull.Measure,
  ExamField.MedicationFull.Form,
  ExamField.MedicationFull.Route,
  ExamField.MedicationFull.Duration,
  ExamField.MedicationFull.Client,
  ExamField.MedicationFull.Pharmacist,
  ExamField.Diagnosis.HealthR1,
  ExamField.Diagnosis.HealthL1,
  ExamField.Diagnosis.HealthR2,
  ExamField.Diagnosis.HealthL2,
  ExamField.Diagnosis.HealthR3,
  ExamField.Diagnosis.HealthL3,
  ExamField.Diagnosis.HealthR4,
  ExamField.Diagnosis.HealthL4,
  ExamField.Diagnosis.HealthR5,
  ExamField.Diagnosis.HealthL5,
  ExamField.Diagnosis.HealthR6,
  ExamField.Diagnosis.HealthL6,
  ExamField.Diagnosis.HealthR7,
  ExamField.Diagnosis.HealthL7,
  ExamField.Diagnosis.HealthR8,
  ExamField.Diagnosis.HealthL8,
  ExamField.Diagnosis.HealthR9,
  ExamField.Diagnosis.HealthL9,
  ExamField.Diagnosis.HealthR10,
  ExamField.Diagnosis.HealthL10,
  ExamField.Diagnosis.RefractionR1,
  ExamField.Diagnosis.RefractionL1,
  ExamField.Diagnosis.RefractionR2,
  ExamField.Diagnosis.RefractionL2,
  ExamField.Diagnosis.BinocularR1,
  ExamField.Diagnosis.BinocularL1,
  ExamField.Diagnosis.BinocularR2,
  ExamField.Diagnosis.BinocularL2,
  ExamField.Diagnosis.RecallR1,
  ExamField.Diagnosis.RecallL1,
  ExamField.Diagnosis.RecallR2,
  ExamField.Diagnosis.RecallL2,
  ExamField.Diagnosis.Notes,
  ExamField.Habitual.Lens,
  ExamField.Habitual.MatteTinted,
  ExamField.Habitual.ODSphere,
  ExamField.Habitual.ODCylinder,
  ExamField.Habitual.ODAxis,
  ExamField.Habitual.ODAdd,
  ExamField.Habitual.ODPD,
  ExamField.Habitual.ODAcuity,
  ExamField.Habitual.OSSphere,
  ExamField.Habitual.OSCylinder,
  ExamField.Habitual.OSAxis,
  ExamField.Habitual.OSAdd,
  ExamField.Habitual.OSPD,
  ExamField.Habitual.OSAcuity,
  ExamField.Habitual.Method,
  ExamField.Habitual.OUAcuity,
  ExamField.Habitual.Notes,
  ExamField.Habitual.RxDate,
  ExamField.Habitual.RxExpiry,
  ExamField.Habitual.ODPrism,
  ExamField.Habitual.ODOrient,
  ExamField.Habitual.ODPrism2,
  ExamField.Habitual.ODOrient2,
  ExamField.Habitual.OSPrism,
  ExamField.Habitual.OSOrient,
  ExamField.Habitual.OSPrism2,
  ExamField.Habitual.OSOrient2,
  ExamField.Habitual2.Lens,
  ExamField.Habitual2.MatteTinted,
  ExamField.Habitual2.ODSphere,
  ExamField.Habitual2.ODCylinder,
  ExamField.Habitual2.ODAxis,
  ExamField.Habitual2.ODAdd,
  ExamField.Habitual2.ODPd,
  ExamField.Habitual2.ODAcuity,
  ExamField.Habitual2.OSSphere,
  ExamField.Habitual2.OSCylinder,
  ExamField.Habitual2.OSAxis,
  ExamField.Habitual2.OSAdd,
  ExamField.Habitual2.OSPd,
  ExamField.Habitual2.OSAcuity,
  ExamField.Habitual2.Method,
  ExamField.Habitual2.OUAcuity,
  ExamField.Habitual2.Notes,
  ExamField.Habitual2.RxDate,
  ExamField.Habitual2.RxExpiry,
  ExamField.Habitual2.ODPrism,
  ExamField.Habitual2.ODOrient,
  ExamField.Habitual2.ODPrism2,
  ExamField.Habitual2.ODOrient2,
  ExamField.Habitual2.OSPrism,
  ExamField.Habitual2.OSOrient,
  ExamField.Habitual2.OSPrism2,
  ExamField.Habitual2.OSOrient2,
  ExamField.Tonometry.ODIOP,
  ExamField.Tonometry.OSIOP,
  ExamField.Tonometry.ODIOP2,
  ExamField.Tonometry.OSIOP2,
  ExamField.Tonometry.ODIOP3,
  ExamField.Tonometry.OSIOP3,
  ExamField.Tonometry.Time,
  ExamField.Tonometry.Method,
  ExamField.Tonometry.Notes,
  ExamField.Tonometry2.ODIOP,
  ExamField.Tonometry2.OSIOP,
  ExamField.Tonometry2.ODIOP2,
  ExamField.Tonometry2.OSIOP2,
  ExamField.Tonometry2.ODIOP3,
  ExamField.Tonometry2.OSIOP3,
  ExamField.Tonometry2.Time,
  ExamField.Tonometry2.Method,
  ExamField.Tonometry2.Notes,
  ExamField.Over.Over,
  ExamField.Over.ODSphere,
  ExamField.Over.ODCylinder,
  ExamField.Over.ODAxis,
  ExamField.Over.ODAcuity,
  ExamField.Over.OSSphere,
  ExamField.Over.OSCylinder,
  ExamField.Over.OSAxis,
  ExamField.Over.OSAcuity,
  ExamField.Over.Notes,
  ExamField.Keratom.ODHoriz,
  ExamField.Keratom.ODAxis,
  ExamField.Keratom.ODVert,
  ExamField.Keratom.OSHoriz,
  ExamField.Keratom.OSAxis,
  ExamField.Keratom.OSVert,
  ExamField.Keratom.ODHoriz2,
  ExamField.Keratom.ODAxis2,
  ExamField.Keratom.ODVert2,
  ExamField.Keratom.OSHoriz2,
  ExamField.Keratom.OSAxis2,
  ExamField.Keratom.OSVert2,
  ExamField.Keratom.Method,
  ExamField.Pachymetry.ODThickness,
  ExamField.Pachymetry.ODMmhg,
  ExamField.Pachymetry.OSThickness,
  ExamField.Pachymetry.OSMmhg,
  ExamField.Autorefraction.ODSphere,
  ExamField.Autorefraction.ODCylinder,
  ExamField.Autorefraction.ODAxis,
  ExamField.Autorefraction.ODAcuity,
  ExamField.Autorefraction.OSSphere,
  ExamField.Autorefraction.OSCylinder,
  ExamField.Autorefraction.OSAxis,
  ExamField.Autorefraction.OSAcuity,
  ExamField.Autorefraction.Method,
  ExamField.Autorefraction.Notes,
  ExamField.Subjective.ODSphere,
  ExamField.Subjective.ODCylinder,
  ExamField.Subjective.ODAxis,
  ExamField.Subjective.ODAcuity,
  ExamField.Subjective.OSSphere,
  ExamField.Subjective.OSCylinder,
  ExamField.Subjective.OSAxis,
  ExamField.Subjective.OSAcuity,
  ExamField.Subjective.Method,
  ExamField.Subjective.OUAcuity,
  ExamField.Subjective.Notes,
  ExamField.Subjective.ODPrism,
  ExamField.Subjective.ODOrient,
  ExamField.Subjective.ODPrism2,
  ExamField.Subjective.ODOrient2,
  ExamField.Subjective.OSPrism,
  ExamField.Subjective.OSOrient,
  ExamField.Subjective.OSPrism2,
  ExamField.Subjective.OSOrient2,
  ExamField.FinalAdd.WorkingDistance,
  ExamField.FinalAdd.ODFinalAdd,
  ExamField.FinalAdd.ODAcuity,
  ExamField.FinalAdd.OSFinalAdd,
  ExamField.FinalAdd.OSAcuity,
  ExamField.FinalAdd.OUAcuity,
  ExamField.FinalAdd.Notes,
  ExamField.Balance.ODSphere,
  ExamField.Balance.ODCylinder,
  ExamField.Balance.ODAxis,
  ExamField.Balance.ODAcuity,
  ExamField.Balance.OSSphere,
  ExamField.Balance.OSCylinder,
  ExamField.Balance.OSAxis,
  ExamField.Balance.OSAcuity,
  ExamField.Balance.Method,
  ExamField.Balance.OUAcuity,
  ExamField.Balance.Notes,
  ExamField.Balance.ODPrism,
  ExamField.Balance.ODOrient,
  ExamField.Balance.ODPrism2,
  ExamField.Balance.ODOrient2,
  ExamField.Balance.OSPrism,
  ExamField.Balance.OSOrient,
  ExamField.Balance.OSPrism2,
  ExamField.Balance.OSOrient2,
  ExamField.FinalRx.Lens,
  ExamField.FinalRx.MatteTinted,
  ExamField.FinalRx.ODSphere,
  ExamField.FinalRx.ODCylinder,
  ExamField.FinalRx.ODAxis,
  ExamField.FinalRx.ODAdd,
  ExamField.FinalRx.ODPd,
  ExamField.FinalRx.ODAcuity,
  ExamField.FinalRx.OSSphere,
  ExamField.FinalRx.OSCylinder,
  ExamField.FinalRx.OSAxis,
  ExamField.FinalRx.OSAdd,
  ExamField.FinalRx.OSPd,
  ExamField.FinalRx.OSAcuity,
  ExamField.FinalRx.Method,
  ExamField.FinalRx.OUAcuity,
  ExamField.FinalRx.Notes,
  ExamField.FinalRx.RxDate,
  ExamField.FinalRx.RxExpiry,
  ExamField.FinalRx.ODPrism,
  ExamField.FinalRx.ODOrient,
  ExamField.FinalRx.ODPrism2,
  ExamField.FinalRx.ODOrient2,
  ExamField.FinalRx.OSPrism,
  ExamField.FinalRx.OSOrient,
  ExamField.FinalRx.OSPrism2,
  ExamField.FinalRx.OSOrient2,
  ExamField.FinalRx2.Lens,
  ExamField.FinalRx2.MatteTinted,
  ExamField.FinalRx2.ODSphere,
  ExamField.FinalRx2.ODCylinder,
  ExamField.FinalRx2.ODAxis,
  ExamField.FinalRx2.ODAdd,
  ExamField.FinalRx2.ODPd,
  ExamField.FinalRx2.ODAcuity,
  ExamField.FinalRx2.OSSphere,
  ExamField.FinalRx2.OSCylinder,
  ExamField.FinalRx2.OSAxis,
  ExamField.FinalRx2.OSAdd,
  ExamField.FinalRx2.OSPd,
  ExamField.FinalRx2.OSAcuity,
  ExamField.FinalRx2.Method,
  ExamField.FinalRx2.OUAcuity,
  ExamField.FinalRx2.Notes,
  ExamField.FinalRx2.RxDate,
  ExamField.FinalRx2.RxExpiry,
  ExamField.FinalRx2.ODPrism,
  ExamField.FinalRx2.ODOrient,
  ExamField.FinalRx2.ODPrism2,
  ExamField.FinalRx2.ODOrient2,
  ExamField.FinalRx2.OSPrism,
  ExamField.FinalRx2.OSOrient,
  ExamField.FinalRx2.OSPrism2,
  ExamField.FinalRx2.OSOrient2,
  ExamField.Cycloplegic.ODSphere,
  ExamField.Cycloplegic.ODCylinder,
  ExamField.Cycloplegic.ODAxis,
  ExamField.Cycloplegic.ODAcuity,
  ExamField.Cycloplegic.OSSphere,
  ExamField.Cycloplegic.OSCylinder,
  ExamField.Cycloplegic.OSAxis,
  ExamField.Cycloplegic.OSAcuity,
  ExamField.Cycloplegic.Method,
  ExamField.Cycloplegic.OUAcuity,
  ExamField.Cycloplegic.Notes,
  ExamField.Pd.DxOD,
  ExamField.Pd.DxOS,
  ExamField.Pd.DxOU,
  ExamField.Pd.NxOD,
  ExamField.Pd.NxOS,
  ExamField.Pd.NxOU,
  ExamField.Pd.Notes,
  ExamField.Other.DxOD,
  ExamField.Other.DxOS,
  ExamField.Other.DxOU,
  ExamField.Other.NxOD,
  ExamField.Other.NxOS,
  ExamField.Other.NxOU,
  ExamField.Other.Notes,
  ExamField.CLTrial.Status,  
  ExamField.CLTrial.ODSupplier,  
  ExamField.CLTrial.ODType, 
  ExamField.CLTrial.ODName,  
  ExamField.CLTrial.ODColor,  
  ExamField.CLTrial.OSSupplier,  
  ExamField.CLTrial.OSType,  
  ExamField.CLTrial.OSName,  
  ExamField.CLTrial.OSColor,  
  ExamField.CLTrial.ODBc,  
  ExamField.CLTrial.ODDia,  
  ExamField.CLTrial.ODSphere,  
  ExamField.CLTrial.ODCylinder,  
  ExamField.CLTrial.ODAxis,  
  ExamField.CLTrial.ODAdd,  
  ExamField.CLTrial.OSBc,  
  ExamField.CLTrial.OSDia,  
  ExamField.CLTrial.OSSphere,  
  ExamField.CLTrial.OSCylinder,  
  ExamField.CLTrial.OSAxis,  
  ExamField.CLTrial.OSAdd,  
  ExamField.CLTrial.ExpiryDate,  
  ExamField.CLTrial.FittingNote,  
  ExamField.CLTrial.Notes,  
  ExamField.CLTrial.Solution,  
  ExamField.CLTrial2.Status,  
  ExamField.CLTrial2.ODSupplier,  
  ExamField.CLTrial2.ODType,  
  ExamField.CLTrial2.ODName,  
  ExamField.CLTrial2.ODColor,  
  ExamField.CLTrial2.OSSupplier,  
  ExamField.CLTrial2.OSType,  
  ExamField.CLTrial2.OSName,  
  ExamField.CLTrial2.OSColor,  
  ExamField.CLTrial2.ODBc,  
  ExamField.CLTrial2.ODDia,  
  ExamField.CLTrial2.ODSphere, 
  ExamField.CLTrial2.ODCylinder,  
  ExamField.CLTrial2.ODAxis,  
  ExamField.CLTrial2.ODAdd,  
  ExamField.CLTrial2.OSBc,  
  ExamField.CLTrial2.OSDia,  
  ExamField.CLTrial2.OSSphere,  
  ExamField.CLTrial2.OSCylinder,  
  ExamField.CLTrial2.OSAxis,  
  ExamField.CLTrial2.OSAdd,  
  ExamField.CLTrial2.ExpiryDate,  
  ExamField.CLTrial2.FittingNote,  
  ExamField.CLTrial2.Notes,  
  ExamField.CLTrial2.Solution,
  ExamField.CLFinal.Date,
  ExamField.CLFinal.Status,
  ExamField.CLFinal.ODSupplier,
  ExamField.CLFinal.ODType,
  ExamField.CLFinal.ODName,
  ExamField.CLFinal.ODColor,
  ExamField.CLFinal.OSSupplier,
  ExamField.CLFinal.OSType,
  ExamField.CLFinal.OSName,
  ExamField.CLFinal.OSColor,
  ExamField.CLFinal.ODBc,
  ExamField.CLFinal.ODDia,
  ExamField.CLFinal.ODSphere,
  ExamField.CLFinal.ODCylinder,
  ExamField.CLFinal.ODAxis,
  ExamField.CLFinal.ODAdd,
  ExamField.CLFinal.OSBc,
  ExamField.CLFinal.OSDia,
  ExamField.CLFinal.OSSphere,
  ExamField.CLFinal.OSCylinder,
  ExamField.CLFinal.OSAxis,
  ExamField.CLFinal.OSAdd,
  ExamField.CLFinal.ExpiryDate,
  ExamField.CLFinal.FittingNote,
  ExamField.CLFinal.Notes,
  ExamField.CLFinal.Solution,
  ExamField.AnteriorCL.ODCentration,
  ExamField.AnteriorCL.OSCentration,
  ExamField.AnteriorCL.ODMovement,
  ExamField.AnteriorCL.OSMovement,
  ExamField.AnteriorCL.ODRotation,
  ExamField.AnteriorCL.OSRotation,
  ExamField.AnteriorCL.ODCondition,
  ExamField.AnteriorCL.OSCondition,
  ExamField.AnteriorCL.ODVisualAcuity,
  ExamField.AnteriorCL.OSVisualAcuity,
  ExamField.AnteriorCL.ODPuncta,
  ExamField.AnteriorCL.OSPuncta,
  ExamField.AnteriorCL.Notes,
  ExamField.ContactLens.Date,
  ExamField.ContactLens.HowLong,
  ExamField.ContactLens.Habits,
  ExamField.ContactLens.ODType,
  ExamField.ContactLens.OSType,
  ExamField.ContactLens.Solution,
  ExamField.PosteriorPhoto.Date,
  ExamField.PosteriorPhoto.Photos,
  ExamField.PosteriorPhoto.ODResults,
  ExamField.PosteriorPhoto.OSResults,
  ExamField.PosteriorPhoto.Notes,
  ExamField.Eom.Eom,
  ExamField.Eom.Notes,
  ExamField.Npc.Npc,
  ExamField.Npc.Dominance,
  ExamField.Npc.Notes,
  ExamField.Bcc.Bcc,
  ExamField.Bcc.Bpa,
  ExamField.Bcc.Bma
]

const ExcludeFields = [
  ExamField.Keratom.Date,
  ExamField.Keratom.ODHoriz,
  ExamField.Keratom.ODAxis,
  ExamField.Keratom.ODVert,
  ExamField.Keratom.OSHoriz,
  ExamField.Keratom.OSAxis,
  ExamField.Keratom.OSVert,
  ExamField.Keratom.ODHoriz2,
  ExamField.Keratom.ODAxis2,
  ExamField.Keratom.ODVert2,
  ExamField.Keratom.OSHoriz2,
  ExamField.Keratom.OSAxis2,
  ExamField.Keratom.OSVert2,
  ExamField.Keratom.Method,
  ExamField.Pachymetry.Date,
  ExamField.Pachymetry.ODThickness,
  ExamField.Pachymetry.ODMmhg,
  ExamField.Pachymetry.OSThickness,
  ExamField.Pachymetry.OSMmhg,
  ExamField.Autorefraction.Date,
  ExamField.Autorefraction.ODSphere,
  ExamField.Autorefraction.ODCylinder,
  ExamField.Autorefraction.ODAxis,
  ExamField.Autorefraction.ODAcuity,
  ExamField.Autorefraction.OSSphere,
  ExamField.Autorefraction.OSCylinder,
  ExamField.Autorefraction.OSAxis,
  ExamField.Autorefraction.OSAcuity,
  ExamField.Autorefraction.Method,
  ExamField.Autorefraction.Notes,
  ExamField.Tonometry.Date,
  ExamField.Tonometry.ODIOP,
  ExamField.Tonometry.OSIOP,
  ExamField.Tonometry.ODIOP2,
  ExamField.Tonometry.OSIOP2,
  ExamField.Tonometry.ODIOP3,
  ExamField.Tonometry.OSIOP3,
  ExamField.Tonometry.Time,
  ExamField.Tonometry.Method,
  ExamField.Tonometry.Notes
]

const IntakeFields = [
  Name.Intake.FirstName,
  Name.Intake.LastName,
  Name.Intake.Phone,
  Name.Intake.Email,
  Name.Intake.Gender,
  Name.Intake.ExistingPatient,
  Name.Intake.HCNO,
  Name.Intake.DOB,
  Name.Intake.Address,
  Name.Intake.City,
  Name.Intake.Province,
  Name.Intake.Postal,
  Name.Intake.ReasonforVisit,
  Name.Intake.Symptoms,
  Name.Intake.Smoker,
  Name.Intake.Pregnant,
  Name.Intake.Diabetic,
  Name.Intake.BloodSugarLevel,
  Name.Intake.EyeInjury,
  Name.Intake.EyeSurgery,
  Name.Intake.MedicalConditions,
  Name.Intake.CurrentMedications,
  Name.Intake.Allergies,
  Name.Intake.FamilyHistory,
  Name.Intake.InsurerName,
  Name.Intake.PolicyNumber,
  Name.Intake.GroupNumber,
  Name.Intake.RelationtoPolicyholder,
  Name.Intake.EmergencyContactName,
  Name.Intake.EmergencyRelationship,
  Name.Intake.EmergencyContactPhone,
  Name.Intake.EmergencyAlternativePhone,
  Name.Client.FirstName,
  Name.Client.LastName,
  Name.Client.Dob,
  Name.Client.Phone,
  Name.Client.Email,
  Name.Common.GenderId,
  Name.City.Id,
  Name.Client.Address,
  Name.Client.Postal,
]

const AllDates = [
  ExamField.Complaint.Date,
  ExamField.Medical.Date,
  ExamField.Unaided.Date,
  ExamField.Aided.Date,
  ExamField.Pupils.Date,
  ExamField.Eom.Date,
  ExamField.Prelims.Date,
  ExamField.CoverTest.Date,
  ExamField.Fields.Date,
  ExamField.ColorVision.Date,
  ExamField.ColorVision2.Date,
  ExamField.Npc.Date,
  ExamField.Stereopsis.Date,
  ExamField.Additional.Date,
  ExamField.Binocular.Date,
  ExamField.Retino.Date,
  ExamField.Amplitude.Date,
  ExamField.Bcc.Date,
  ExamField.Habitual.Date,
  ExamField.FinalAdd.Date,
  ExamField.Habitual2.Date,
  ExamField.Over.Date,
  ExamField.Balance.Date,
  ExamField.Keratom.Date,
  ExamField.Pachymetry.Date,
  ExamField.Autorefraction.Date,
  ExamField.Pd.Date,
  ExamField.Other.Date,
  ExamField.FinalRx.Date,
  ExamField.Subjective.Date,
  ExamField.FinalRx2.Date,
  ExamField.Cycloplegic.Date,
  ExamField.Drops.Date,
  ExamField.Anterior.Date,
  ExamField.Puncta.Date,
  ExamField.Tonometry.Date,
  ExamField.Posterior.Date,
  ExamField.Tonometry2.Date,
  ExamField.PosteriorPhoto.Date,
  ExamField.Gonioscopy.Date,
  ExamField.Fields2.Date,
  ExamField.CLTrial.Date,
  ExamField.CLTrial2.Date,
  ExamField.CLFinal.Date,
  ExamField.AnteriorCL.Date,
  ExamField.ContactLens.Date,
  ExamField.Prescription.Date,
  ExamField.Medications.Date,
  ExamField.MedicationFull.Date,
  ExamField.Diagnosis.Date,
];

// const SphereODGroup = [
//   ExamField.FinalRx.ODSphere,
//   ExamField.FinalRx2.ODSphere,
//   ExamField.Habitual.ODSphere,
//   ExamField.Habitual2.ODSphere,
//   ExamField.Cycloplegic.ODSphere,
//   ExamField.CLTrial.ODSphere, 
//   ExamField.CLTrial2.ODSphere, 
//   ExamField.CLFinal.ODSphere,
//   ExamField.Retino.ODSphere,
//   ExamField.Over.ODSphere,
//   ExamField.Static.ODSphere,
//   ExamField.Subjective.ODSphere,
//   ExamField.Balance.ODSphere,
// ];

// const SphereOSGroup = [
//   ExamField.FinalRx.OSSphere,
//   ExamField.FinalRx2.OSSphere,
//   ExamField.Habitual.OSSphere,
//   ExamField.Habitual2.OSSphere,
//   ExamField.Cycloplegic.OSSphere,
//   ExamField.CLTrial.OSSphere, 
//   ExamField.CLTrial2.OSSphere, 
//   ExamField.CLFinal.OSSphere,
//   ExamField.Retino.OSSphere,
//   ExamField.Over.OSSphere,
//   ExamField.Static.OSSphere,
//   ExamField.Subjective.OSSphere,
//   ExamField.Balance.OSSphere,
// ];

// const HabitualMapGroup = {
//   EDIT: 'editform',
//   COMPANY: "company",
//   LOCATION: "location",
//   SETTINGS: "settings",
// }


const ProvinceName: Record<number, string> = {
    10: "AB", // Alberta
    11: "BC", // British Columbia   
    12: "MB", // Manitoba
    13: "NB", // New Brunswick  
    14: "NL", // Newfoundland and Labrador
    15: "NS", // Nova Scotia
    16: "ON", // Ontario
    17: "PE", // Prince Edward Island
    18: "QC", // Quebec
    19: "SK", // Saskatchewan 
    20: "NT", // Northwest Territories
    21: "NU", // Nunavut
    22: "YT", // Yukon
}


const TemplateField: Record<string, string> = {
    exam_date: "EXAMDATE",
    
    client_first_name: "CLNTFIRST",
    client_middle_name: "CLNTMIDDLE",
    client_last_name: "CLNTLAST",
    client_cell: "CLNTPHONE1",
    client_phone: "CLNTPHONE2",
    client_mobile: "CLNTPHONE3",
    client_email: "CLNTEMAIL",
    client_address: 'CLNTADDRESS',
    client_postal: 'CLNTZIP',
    client_health_card: 'CLNTHCNO',
    client_dob: 'CLNTDOB',

    doctor_short_name: 'DCTRSNAME',
    doctor_first_name: 'DCTRFIRST',
    doctor_middle_name: 'DCTRMIDDLE',
    doctor_last_name: 'DCTRLAST',
    doctor_phone: 'DCTRPHONE',
    doctor_email: 'DCTREMAIL',
    doctor_address: 'DCTRADDRESS',
    doctor_postal: 'DCTRZIP',
    doctor_id: 'DCTRID',
    doctor_pay_to_uli: 'DCTRULIID',
    doctor_locum_arrangement: 'DCTRLAID',
    doctor_skill_code: 'DCTRSCID',
    doctor_facility_number: 'DCTRFNID',
    doctor_functional_centre: 'DCTRFCID',
    doctor_pay_to_code: 'DCTRPTCID',
    doctor_business_arrangement: 'DCTRBAID',
    doctor_coop_id: 'DCTRCOID',
    doctor_license_number: 'DCTRLICID',
    doctor_signature: 'DCTRSIGN',

    company_name: 'CMPYNAME',
    company_address: 'CMPYADDRESS',
    company_postal: 'CMPYPOSTAL',
    company_phone: 'CMPYPHONE',
    company_email: 'CMPYEMAIL',
    company_gst: 'CMPYGST',

    location_name: 'LCTNNAME',
    location_address: 'LCTNADDRESS',
    location_postal: 'LCTNPOSTAL',
    location_phone: 'LCTNPHONE',
    location_email: 'LCTNEMAIL',
    location_website: 'LCTNWEBSITE',
    location_print: 'LCTNPRINT',

    recdoctor_first_name: 'RCDRFIRST',
    recdoctor_middle_name: 'RCDRMIDDLE',
    recdoctor_last_name: 'RCDRLAST',
    recdoctor_phone: 'RCDRPHONE',
    recdoctor_email: 'RCDREMAIL',
    recdoctor_address: 'RCDRADDRESS',
    recdoctor_postal: 'RCDRZIP',
    recdoctor_id: 'RCDRID',
    recdoctor_pay_to_uli: 'RCDRULIID',
    recdoctor_locum_arrangement: 'RCDRLAID',
    recdoctor_skill_code: 'RCDRSCID',
    recdoctor_facility_number: 'RCDRFNID',
    recdoctor_functional_centre: 'RCDRFCID',
    recdoctor_pay_to_code: 'RCDRPTCID',
    recdoctor_business_arrangement: 'RCDRBAID',
    recdoctor_coop_id: 'RCDRCOID',
    recdoctor_license_number: 'RCDRLICID',
};

export const Code = {
  File: FileName,
  Image: ImageName,
  Mapping: DropFieldsMapping,
  LocalKey: localStorageKey,
  Command: CommandName,
  Key: CommandKey,
  Control: controlName,
  Path: paths,
  GroupModoOfPay: GroupModoOfPay,
  Term: TermCommon,
  Tab: Tab,
  Title: Title,
  Info: Info,
  Class: Class,
  UrlPara: urlParameter,
  Denomination: Denomination,
  ReportChart: ReportChart,
  ReportColumn: ReportColumn,
  Privilege: Privilege,
  Group: Group,
  Align: Align,
  Option:{
    Active: ActiveStatus,
    Sort: SortBy,
    Session: Session,
    Category: ProductCategory,
    ModeofPay: ModeofPay,
    ColumnType: ColumnType,
    ColumnSummary: ColumnSummary,
    Oriantation: Oriantation,
    DataView: DataView,
    Common: CommonOptions,
    MessageSegment: MessageSegment,
    Billing: BillingStatus,
    Action: ActionType,
    Segment: SegmentType,
    ActionAHS: ActionAHS,
    Title: OptionTitle,
    Control: ControlType,
    ControlTitle: ControlTitleMap,
    ExamType: ExamType,
    StockId: StockId,
    DocumentType: DocumentType,
    Product: ProductId,
    Credit: CreditOptions,
    Priority: PriorityType,
  },
  Format:{
    DateTime: DateTimeFormat,
    Client: ClientNameFormat,
    Sno: SnoFormat,
    //HtmlData: HtmlDataFormat
  },
  Map:{
    TemplateField: TemplateField,
    Province: ProvinceName,
  },
  Calendar:{
    View: CalendarView
  },
  Chart:{
    Type: ChartType,
    Color: ChartColor,
  },
  Message:{
    type: MessageType,
    None: MessageNone,
  },
  Exam:{
    Option: ExamOption,
    Map: ExamMap,
    Field: ExamField,
    GroupId: ExamFieldGroup,
    FieldGroup:{
      AllFields: AllFields,
      ExcludeFields: ExcludeFields,
      IntakeFields: IntakeFields,
      AllDates: AllDates,
      Complaint: Complaint,
      Ocular: Ocular, 
      Medical: Medical,
      Unaided: Unaided,
      Aided: Aided,
      Pupils: Pupils,
      Fields: Fields,
      CoverTest : CoverTest,
      ColorVision: ColorVision,
      ColorVision2: ColorVision2,
      Stereopsis: Stereopsis,
      Additional: Additional,
      Binocular: Binocular,
      Retino: Retino,
      Amplitude: Amplitude,
      Drops: Drops,
      Anterior: Anterior,
      Puncta: Puncta,
      Posterior: Posterior,
      Gonioscopy: Gonioscopy,
      Fields2: Fields2,
      Prescription: Prescription,
      Medications: Medications,
      MedicationFull: MedicationFull,
      Diagnosis: Diagnosis,
      Habitual: Habitual,
      Habitual2: Habitual2,
      Tonometry: Tonometry,
      Tonometry2: Tonometry2,
      Over: Over,
      Keratom: Keratom,
      Pachymetry: Pachymetry,
      Subjective: Subjective,
      Autorefraction: Autorefraction,
      FinalAdd: FinalAdd,
      Balance: Balance,
      FinalRx: FinalRx,
      FinalRx2: FinalRx2,
      Cycloplegic: Cycloplegic,
      Pd: Pd,
      Other: Other,
      CLTrial: CLTrial,
      CLTrial2: CLTrial2,
      CLFinal: CLFinal,
      AnteriorCL: AnteriorCL,
      ContactLens: ContactLens,
      PosteriorPhoto: PosteriorPhoto,
      Eom: Eom,
      Prelims: Prelims,
      Npc: Npc,
      Bcc: Bcc,
    },
    // CopyGroup:{
    //   SphereOD: SphereODGroup,
    //   SphereOS: SphereOSGroup
    // }
  },
  Style:{
    FormOption:FormOption,
    ListOption:ListOption,
    SearchOption:SearchOption,
  },
  Html:{
    Tag: HtmlTag,
  },
  Form:{
    Name: FormName,
    Id: FormId,
    Size: FormSize,
    PopupClose: PopupClose,
  },
  Item:{
    NoneCalculateFields: ItemNoneCalculateFields,
  }
 
}